
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8CeBV", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eK5zz = parcelRequire("eK5zz");


var $bssir = parcelRequire("bssir");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");





var $gtD4K = parcelRequire("gtD4K");




var $keVvA = parcelRequire("keVvA");


var $gdv5Z = parcelRequire("gdv5Z");


var $4A7Gn = parcelRequire("4A7Gn");

var $gCbPZ = parcelRequire("gCbPZ");

var $0DTaW = parcelRequire("0DTaW");

var $d2kvf = parcelRequire("d2kvf");

/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 






var $fFa3V = parcelRequire("fFa3V");


var $4kfV4 = parcelRequire("4kfV4");


var $hTKp4 = parcelRequire("hTKp4");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");


var $caX7N = parcelRequire("caX7N");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bWLcG = parcelRequire("bWLcG");




parcelRequire("42omo");





var $ccHMk = parcelRequire("ccHMk");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");




const $168e793736f667f3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    alertIcon: {
        id: "admin-hub-sidebar.error-section.alert-icon",
        defaultMessage: "Alert icon"
    },
    errorDefaultHeader: {
        id: "admin-hub-sidebar-next.error.default.header",
        defaultMessage: "We're having trouble loading this content."
    },
    errorDefaultDescription: {
        id: "admin-hub-sidebar-next.error.default.description",
        defaultMessage: "Something went wrong on our end. Close the panel or try again."
    },
    confirmationModalTitle: {
        id: "admin-hub-sidebar-next.confirmation-modal.title",
        defaultMessage: "You have unsaved changes"
    },
    confirmationModalDescription: {
        id: "admin-hub-sidebar-next.confirmation-modal.description",
        defaultMessage: "You\u2019re about to close the sidebar which will discard your unsaved changes."
    },
    confirmationModalCancel: {
        id: "admin-hub-sidebar-next.confirmation-modal.cancel",
        defaultMessage: "Cancel"
    },
    confirmationModalConfirm: {
        id: "admin-hub-sidebar-next.confirmation-modal.confirm",
        defaultMessage: "Discard changes"
    }
});


const $40e45d4a0e0512a5$export$a849bb6cb5b271a9 = ({ isOpen: isOpen, shouldReturnFocus: shouldReturnFocus, onClose: onClose, onCancelClicked: onCancelClicked, onConfirmClicked: onConfirmClicked })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: onClose,
            testId: "sidebar-confirmation-modal",
            shouldReturnFocus: shouldReturnFocus,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        appearance: "warning",
                        children: intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).confirmationModalTitle)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).confirmationModalDescription)
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            testId: "sidebar-confirmation-modal-cancel-btn",
                            appearance: "subtle",
                            onClick: onCancelClicked,
                            children: intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).confirmationModalCancel)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            testId: "sidebar-confirmation-modal-confirm-btn",
                            appearance: "warning",
                            onClick: onConfirmClicked,
                            children: intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).confirmationModalConfirm)
                        })
                    ]
                })
            ]
        })
    });
};





parcelRequire("42omo");









parcelRequire("42omo");


var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");

const $684eda8450c167ba$var$Section = ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                borderRadius: "8px",
                isShimmering: true,
                width: "100%",
                height: "var(--ds-space-200, 16px)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                borderRadius: "8px",
                isShimmering: true,
                width: "100%",
                height: "var(--ds-space-200, 16px)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                borderRadius: "8px",
                isShimmering: true,
                width: "33%",
                height: "var(--ds-space-200, 16px)"
            })
        ]
    });
const $684eda8450c167ba$export$44c18d210d5de37b = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.400",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($684eda8450c167ba$var$Section, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($684eda8450c167ba$var$Section, {}),
            /*#__PURE__*/ (0, $l998X.jsx)($684eda8450c167ba$var$Section, {})
        ]
    });
};


const $b0d5df57c5912b0c$var$styles = (0, $ecnYn.xcss)({
    width: '100%',
    marginTop: 'space.400',
    marginBottom: 'space.400',
    marginLeft: 'space.400'
});
const $b0d5df57c5912b0c$var$loadingStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    padding: 'space.300'
});
const $b0d5df57c5912b0c$export$c4783ce0872a9427 = ({ hasError: hasError, isExpanded: isExpanded, isLoading: isLoading, children: children })=>{
    // On error, it expands out the error section from the main section
    if (!isExpanded || hasError) return null;
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-expanded-loading",
        xcss: [
            $b0d5df57c5912b0c$var$styles,
            $b0d5df57c5912b0c$var$loadingStyles
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $684eda8450c167ba$export$44c18d210d5de37b), {})
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-expanded",
        xcss: $b0d5df57c5912b0c$var$styles,
        children: children
    });
};


































parcelRequire("42omo");





var $cO1el = parcelRequire("cO1el");




var $1GzhS = parcelRequire("1GzhS");




var $af953b4ac68cc73e$exports = {};
$af953b4ac68cc73e$exports = new URL("alert-icon.236d7fa8.svg", import.meta.url).toString();


const $d5d5765f2ca14e6c$var$descriptionStyles = (0, $ecnYn.xcss)({
    textAlign: 'center',
    paddingTop: 'space.100'
});
const $d5d5765f2ca14e6c$export$b0bceea2ea86179a = (props)=>{
    const intl = (0, $8C5kA.default)();
    const { header: header = intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).errorDefaultHeader), description: description = intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).errorDefaultDescription) } = props;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        alignInline: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                padding: "space.400",
                children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($af953b4ac68cc73e$exports))),
                    height: "103",
                    "aria-label": intl.formatMessage((0, $168e793736f667f3$export$defe85febe8b728c).alertIcon)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                children: header
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $d5d5765f2ca14e6c$var$descriptionStyles,
                children: description
            })
        ]
    });
};


const $71d639ba64f2a77a$var$paddingStylesWithFooter = (0, $ecnYn.xcss)({
    height: '100%',
    paddingRight: 'space.400',
    paddingLeft: 'space.400'
});
const $71d639ba64f2a77a$var$paddingStylesWithoutFooter = (0, $ecnYn.xcss)({
    height: '100%',
    paddingBottom: 'space.400',
    paddingRight: 'space.400',
    paddingLeft: 'space.400'
});
const $71d639ba64f2a77a$var$errorBoxStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $71d639ba64f2a77a$var$defaultStyles = (0, $ecnYn.xcss)({
    overflowY: 'auto',
    flexGrow: 1
});
const $71d639ba64f2a77a$export$4b2c32e08f77ff18 = (props)=>{
    const { isLoading: isLoading = false, hasError: hasError = false, errorHeader: errorHeader, errorDescription: errorDescription, isFooterShown: isFooterShown, children: children, onBodyScrolled: onBodyScrolled } = props;
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const div = ref.current;
        if (!div) return;
        const handleScroll = ()=>{
            const showTopShadow = div.scrollTop > 0;
            const showBottomShadow = div.scrollHeight - div.scrollTop > div.clientHeight;
            onBodyScrolled({
                showTopShadow: showTopShadow,
                showBottomShadow: showBottomShadow
            });
        };
        // On mount, set the shadow if content is scrollable
        handleScroll();
        // @TODO may need to debounce this
        return (0, $fFa3V.bind)(div, {
            type: 'scroll',
            listener: handleScroll
        });
    }, [
        onBodyScrolled
    ]);
    if (hasError) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-main-error",
        xcss: [
            $71d639ba64f2a77a$var$paddingStylesWithoutFooter,
            $71d639ba64f2a77a$var$errorBoxStyles
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d5d5765f2ca14e6c$export$b0bceea2ea86179a), {
            header: errorHeader,
            description: errorDescription
        })
    });
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-main-loading",
        xcss: [
            $71d639ba64f2a77a$var$paddingStylesWithoutFooter,
            $71d639ba64f2a77a$var$defaultStyles
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $684eda8450c167ba$export$44c18d210d5de37b), {})
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-main",
        ref: ref,
        tabIndex: 0,
        xcss: [
            isFooterShown ? $71d639ba64f2a77a$var$paddingStylesWithFooter : $71d639ba64f2a77a$var$paddingStylesWithoutFooter,
            $71d639ba64f2a77a$var$defaultStyles
        ],
        children: children
    });
};





parcelRequire("42omo");






const $693ec2a611b6ab37$var$styles = (0, $ecnYn.xcss)({
    height: '88px'
});
const $693ec2a611b6ab37$export$e44edfd66c3035b6 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $693ec2a611b6ab37$var$styles
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");






function $8d058cd44dd89ee6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d058cd44dd89ee6$var$containerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.400',
    paddingLeft: 'space.400',
    paddingRight: 'space.400'
});
const $8d058cd44dd89ee6$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    gap: 'space.100'
});
const $8d058cd44dd89ee6$var$buttonStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
// css() required to do custom boxShadow
const $8d058cd44dd89ee6$var$scrolledStyles = {
    name: "8jy5u6",
    styles: "box-shadow:0px -8px 14px -14px rgba(0, 0, 0, 0.4)"
};
const $8d058cd44dd89ee6$export$a06f1c675e846f6f = (props)=>{
    if (!props.buttons?.length) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            props.showDropShadow && $8d058cd44dd89ee6$var$scrolledStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        testId: "sidebar-main-footer",
        as: "footer",
        xcss: $8d058cd44dd89ee6$var$containerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $8d058cd44dd89ee6$var$buttonContainerStyles
    }, props.buttons?.map((Button, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
            key: index,
            xcss: $8d058cd44dd89ee6$var$buttonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(Button, {
            shouldFitContainer: true
        }))))));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $dcJ7R = parcelRequire("dcJ7R");










var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");

const $a9a35db82c8896b0$export$de65de8213222d10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ onClose: onClose }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "sidebar-main-close-btn",
        label: "Close",
        onClick: onClose,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        ref: ref
    });
});
$a9a35db82c8896b0$export$de65de8213222d10.displayName = 'CloseButton';





parcelRequire("42omo");






const $fc81af1dcffe3d7c$var$titleStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    paddingTop: 'space.075'
});
const $fc81af1dcffe3d7c$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $fc81af1dcffe3d7c$var$titleStyles,
        as: "h2",
        children: children
    });
};


function $c227940545b0d389$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c227940545b0d389$var$inlineStyles = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    paddingBottom: 'space.300',
    paddingTop: 'space.400',
    marginLeft: 'space.400',
    marginRight: 'space.400'
});
// css() required to do custom boxShadow
const $c227940545b0d389$var$scrolledStyles = {
    name: "1qpikg0",
    styles: "box-shadow:0px 8px 14px -14px rgba(0, 0, 0, 0.4)"
};
const $c227940545b0d389$export$8b251419efc915eb = ({ title: title, hasError: hasError, showDropShadow: showDropShadow, onClose: onClose, titleComponent: titleComponent, closeButtonRef: closeButtonRef })=>{
    const titleContent = titleComponent ? titleComponent : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fc81af1dcffe3d7c$export$f99233281efd08a0), null, title);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            showDropShadow && $c227940545b0d389$var$scrolledStyles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.200",
        xcss: $c227940545b0d389$var$inlineStyles
    }, !hasError ? titleContent : /*#__PURE__*/ (0, $9K4OG.jsx)("div", null), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a9a35db82c8896b0$export$de65de8213222d10), {
        onClose: onClose,
        ref: closeButtonRef
    })));
};


const $06c9506c9f1aa4fc$var$containerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '100%',
    minWidth: '320px',
    maxWidth: '504px',
    display: 'flex',
    flexDirection: 'column'
});
const $06c9506c9f1aa4fc$var$containerWithExpandedErrorStyles = (0, $ecnYn.xcss)({
    maxWidth: 'initial'
});
const $06c9506c9f1aa4fc$var$containerExpandedStyles = (0, $ecnYn.xcss)({
    maxWidth: '320px',
    [(0, $bWLcG.media).above.lg]: {
        maxWidth: '400px'
    },
    [(0, $bWLcG.media).above.xl]: {
        maxWidth: '486px'
    }
});
const $06c9506c9f1aa4fc$export$b3b6941b6cf0f30 = (props)=>{
    const { title: title, titleComponent: titleComponent, isLoading: isLoading = false, hasError: hasError = false, isExpanded: isExpanded = false, errorHeader: errorHeader, errorDescription: errorDescription, footerButtons: footerButtons = [], children: children, onClose: onClose, closeButtonRef: closeButtonRef } = props;
    const [showHeaderDropShadow, setShowHeaderDropShadow] = (0, $42omo.useState)(false);
    const [showFooterDropShadow, setShowFooterDropShadow] = (0, $42omo.useState)(false);
    const handleOnBodyScrolled = (props)=>{
        setShowHeaderDropShadow(props.showTopShadow);
        setShowFooterDropShadow(props.showBottomShadow);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $06c9506c9f1aa4fc$var$containerStyles,
            hasError && isExpanded && $06c9506c9f1aa4fc$var$containerWithExpandedErrorStyles,
            !hasError && isExpanded && $06c9506c9f1aa4fc$var$containerExpandedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c227940545b0d389$export$8b251419efc915eb), {
                title: title,
                titleComponent: titleComponent,
                hasError: hasError,
                onClose: onClose,
                showDropShadow: showHeaderDropShadow,
                closeButtonRef: closeButtonRef
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $71d639ba64f2a77a$export$4b2c32e08f77ff18), {
                onBodyScrolled: handleOnBodyScrolled,
                isLoading: isLoading,
                hasError: hasError,
                errorHeader: errorHeader,
                errorDescription: errorDescription,
                isFooterShown: footerButtons.length > 0,
                children: children
            }),
            hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $693ec2a611b6ab37$export$e44edfd66c3035b6), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $8d058cd44dd89ee6$export$a06f1c675e846f6f), {
                buttons: footerButtons,
                showDropShadow: showFooterDropShadow
            })
        ]
    });
};


const $6f3e94988e3352fc$var$defaultContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    height: '100%',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #DFE1E6)"}`,
    backgroundColor: 'elevation.surface'
});
const $6f3e94988e3352fc$var$fullBorderStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #DFE1E6)"}`,
    borderRadius: 'radius.large'
});
const $6f3e94988e3352fc$var$sectionsContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $6f3e94988e3352fc$var$expandedStyles = (0, $ecnYn.xcss)({
    width: '1000px',
    zIndex: 'modal',
    [(0, $bWLcG.media).above.lg]: {
        width: '1416px'
    },
    [(0, $bWLcG.media).above.xl]: {
        width: '1560px'
    }
});
const $6f3e94988e3352fc$var$unexpandedStyles = (0, $ecnYn.xcss)({
    width: '320px',
    [(0, $bWLcG.media).above.lg]: {
        width: '400px'
    },
    [(0, $bWLcG.media).above.xl]: {
        width: '486px'
    }
});
function $6f3e94988e3352fc$export$1ba59dacbcbf90fe({ testId: testId, title: title, titleComponent: titleComponent, isLoading: isLoading = false, hasError: hasError = false, errorHeader: errorHeader, errorDescription: errorDescription, isExpanded: isExpanded = false, expandedContent: expandedContent, mainContent: mainContent, footerButtons: footerButtons = [], hasUnsavedChanges: hasUnsavedChanges = false, onClose: onClose, heightOffset: heightOffset, isFullBorderEnabled: isFullBorderEnabled, isVisible: isVisible = true }) {
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = (0, $42omo.useState)(false);
    const ref = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const closeButtonRef = (0, $42omo.useRef)(null);
    const previousIsVisibleRef = (0, $42omo.useRef)(isVisible);
    // if heightOffset is provided subtract it from the sidebar height
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        if (heightOffset !== undefined) ref.current.style.height = `calc(100vh - ${heightOffset}px)`;
    }, [
        heightOffset
    ]);
    (0, $42omo.useEffect)(()=>{
        const beforeUnloadHandler = (event)=>{
            event.preventDefault();
        };
        if (!hasUnsavedChanges) return;
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'beforeunload',
            listener: beforeUnloadHandler
        });
        return unbind;
    }, [
        hasUnsavedChanges
    ]);
    // Track the element that triggered the sidebar to open and move focus to sidebar
    (0, $42omo.useEffect)(()=>{
        const wasVisible = previousIsVisibleRef.current;
        previousIsVisibleRef.current = isVisible;
        if (isVisible && !wasVisible) {
            // Capture the trigger element before moving focus
            const document = (0, $hTKp4.getDocument)();
            if (document?.activeElement instanceof HTMLElement) triggerElementRef.current = document.activeElement;
            // Move focus to the close button in the sidebar
            // Use multiple requestAnimationFrame calls to ensure the sidebar is fully rendered
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (closeButtonRef.current) closeButtonRef.current.focus();
                    else if (ref.current) {
                        // Fallback: focus the container if close button not found
                        if (!ref.current.hasAttribute('tabIndex')) ref.current.setAttribute('tabIndex', '-1');
                        ref.current.focus();
                    }
                });
            });
        }
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    const handleOnClose = ()=>{
        if (hasUnsavedChanges) setIsConfirmationModalOpen(true);
        else {
            if (onClose) onClose();
            // Return focus to the trigger element
            if (triggerElementRef.current) triggerElementRef.current.focus();
        }
    };
    const handleModalConfirmClicked = ()=>{
        setIsConfirmationModalOpen(false);
        if (onClose) onClose();
    // Focus return is handled by the Modal's shouldReturnFocus prop
    };
    const handleModalCancelClicked = ()=>{
        setIsConfirmationModalOpen(false);
    };
    const handleModalOnClose = ()=>{
        setIsConfirmationModalOpen(false);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                testId: testId,
                ref: ref,
                xcss: [
                    $6f3e94988e3352fc$var$defaultContainerStyles,
                    isFullBorderEnabled ? $6f3e94988e3352fc$var$fullBorderStyles : undefined,
                    isExpanded ? $6f3e94988e3352fc$var$expandedStyles : $6f3e94988e3352fc$var$unexpandedStyles
                ],
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $6f3e94988e3352fc$var$sectionsContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $b0d5df57c5912b0c$export$c4783ce0872a9427), {
                            hasError: hasError,
                            isExpanded: isExpanded,
                            isLoading: isLoading,
                            children: expandedContent
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $06c9506c9f1aa4fc$export$b3b6941b6cf0f30), {
                            title: title,
                            titleComponent: titleComponent,
                            isLoading: isLoading,
                            hasError: hasError,
                            isExpanded: isExpanded,
                            errorHeader: errorHeader,
                            errorDescription: errorDescription,
                            mainContent: mainContent,
                            footerButtons: footerButtons,
                            onClose: handleOnClose,
                            closeButtonRef: closeButtonRef,
                            children: mainContent
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $40e45d4a0e0512a5$export$a849bb6cb5b271a9), {
                isOpen: isConfirmationModalOpen,
                onConfirmClicked: handleModalConfirmClicked,
                onCancelClicked: handleModalCancelClicked,
                onClose: handleModalOnClose,
                shouldReturnFocus: triggerElementRef.current ? triggerElementRef : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
                zIndex: "unset",
                children: isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $4kfV4.default), {
                    isTinted: true
                })
            })
        ]
    });
}
const $6f3e94988e3352fc$export$92f34f4ddead32ad = (sidebarProps)=>{
    return sidebarProps.isMotionEnabled ? /*#__PURE__*/ (0, $l998X.jsx)($6f3e94988e3352fc$export$eebdf89b29ddbebc, {
        ...sidebarProps
    }) : /*#__PURE__*/ (0, $l998X.jsx)($6f3e94988e3352fc$export$1ba59dacbcbf90fe, {
        ...sidebarProps
    });
};
var $6f3e94988e3352fc$export$2e2bcd8739ae039 = $6f3e94988e3352fc$export$92f34f4ddead32ad;
const $6f3e94988e3352fc$export$eebdf89b29ddbebc = (sidebarProps)=>{
    const { isVisible: isVisible, ...props } = sidebarProps;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        appear: true,
        children: isVisible && /*#__PURE__*/ (0, $l998X.jsx)((0, $h3cbw.default), {
            enterFrom: "right",
            duration: "medium",
            children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: className,
                    ref: ref,
                    "aria-modal": true,
                    style: {
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)($6f3e94988e3352fc$export$1ba59dacbcbf90fe, {
                        ...props
                    })
                })
        })
    });
};











const $ef8cda562a155a20$export$51fc899c58c5c1e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
const $ef8cda562a155a20$export$295bd9db651c4ee1 = ()=>{
    const ctx = (0, $42omo.useContext)($ef8cda562a155a20$export$51fc899c58c5c1e);
    if (!ctx) throw new Error('useSidePanel must be used within <SidePanelController>');
    return ctx;
};


function $583e7053a645d9a7$export$4ee5b224cada52c3(panel, action) {
    switch(action.type){
        case 'SET_TAB':
            {
                if (!panel) return panel;
                // Update active tab and save to history
                const updatedTabHistory = {
                    ...panel.tabHistory,
                    [panel.mode]: action.tab
                };
                if (panel.mode === 'activity-details') return {
                    ...panel,
                    activeTab: action.tab,
                    tabHistory: updatedTabHistory
                };
                // panel.mode === 'query-details'
                return {
                    ...panel,
                    activeTab: action.tab,
                    tabHistory: updatedTabHistory
                };
            }
        case 'SWITCH_MODE':
            if (!panel) return panel;
            // Don't switch if already in that mode
            if (panel.mode === action.mode) return panel;
            // Mode switching is handled in the component since it changes
            // the entire state structure. This is here for completeness.
            return panel;
        case 'CLOSE':
            // Closing the panel sets state to null
            return null;
        default:
            return panel;
    }
}


const $fd82250eef85a420$export$bc8d97f89653bd3a = ({ state: state, actions: actions, children: children })=>{
    // Centralized effects / derived logic live here
    // Examples: tab normalization, analytics, validation
    (0, $42omo.useEffect)(()=>{
        if (!state) return;
    // You can add effects here such as:
    // - Fire analytics when tab changes
    // - Validate activeTab is valid for the current mode
    // - Perform data fetching when mode/data changes
    }, [
        state
    ]);
    // Dispatch function orchestrates external updates based on reducer result
    const dispatch = (0, $42omo.useCallback)((action)=>{
        const current = state;
        const next = (0, $583e7053a645d9a7$export$4ee5b224cada52c3)(current, action);
        // Orchestrate external updates based on reducer result
        switch(action.type){
            case 'SET_TAB':
                if (!current || !next) break;
                // Call appropriate external handler based on mode
                if (current.mode === 'activity-details') actions.setActivityTab(next.activeTab);
                else actions.setQueryTab(next.activeTab);
                break;
            case 'CLOSE':
                actions.onClose();
                break;
        }
    }, [
        state,
        actions
    ]);
    // Memoize context value to prevent unnecessary re-renders
    const value = (0, $42omo.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ef8cda562a155a20$export$51fc899c58c5c1e).Provider, {
        value: value,
        children: children
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $c4sKh = parcelRequire("c4sKh");


var $a3fRD = parcelRequire("a3fRD");


var $u9agA = parcelRequire("u9agA");


var $9hlns = parcelRequire("9hlns");

const $8d20c6f1a7e0646a$export$2e839de1f68a7db = 10;
const $8d20c6f1a7e0646a$export$b0d0ccc0cf1f706e = 30;


const $eda102eb815ab2b6$export$defe85febe8b728c = {
    relatedActivitiesTab: {
        id: 'organization.audit.log.side-panel.tabs.related-activities.tab',
        defaultMessage: 'Related activities',
        description: 'Title of the audit log side panel tab related activities'
    },
    relatedActivitiesTabBadgeError: {
        id: 'organization.audit.log.side-panel.tabs.related-activities.tab.badge.error',
        defaultMessage: 'You encountered an error while loading related activities',
        description: 'Error message for when loading related activties encounters an error'
    }
};
const $eda102eb815ab2b6$export$745595d7b646149b = ({ isLoading: isLoading = false, hasError: hasError = false, hasMoreEvents: hasMoreEvents, totalEventsCount: totalEventsCount, isSelected: isSelected = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // add 1 to related events count to get 30+ in tab badge
    const numRelatedEvents = hasMoreEvents ? totalEventsCount + 1 : totalEventsCount;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...$eda102eb815ab2b6$export$defe85febe8b728c.relatedActivitiesTab
            }),
            isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "xsmall"
            }) : hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #C9372C)",
                label: formatMessage($eda102eb815ab2b6$export$defe85febe8b728c.relatedActivitiesTabBadgeError)
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                appearance: isSelected ? 'primary' : 'default',
                max: (0, $8d20c6f1a7e0646a$export$b0d0ccc0cf1f706e),
                children: numRelatedEvents
            })
        ]
    });
};





const $9b7393aed24d92c3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    inspectViewTitle: {
        id: "organization.audit.log.side-panel.inspect-view.title",
        defaultMessage: "Inspect view"
    },
    queryDetailsSidePanelComingSoon: {
        id: "organization.audit.log.side-panel.query-details.coming-soon",
        defaultMessage: "Query Details Side Panel - Coming Soon"
    },
    exampleSecondTab: {
        id: "organization.audit.log.side-panel.example-second-tab",
        defaultMessage: "Example Second Tab"
    },
    detailsTab: {
        id: "organization.audit.log.side-panel.tabs.details.tab",
        defaultMessage: "Details"
    },
    jsonTab: {
        id: "organization.audit.log.side-panel.tabs.json.tab",
        defaultMessage: "JSON"
    },
    queryDetailsTab: {
        id: "organization.audit.log.side-panel.tabs.query-details.tab",
        defaultMessage: "Details"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $6767u = parcelRequire("6767u");

const $2b1b49e5891b6a04$var$sizeMap = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $2b1b49e5891b6a04$var$avatarStyles = null;
const $2b1b49e5891b6a04$var$imgStyles = null;
const $2b1b49e5891b6a04$var$Avatar = /*#__PURE__*/ (0, $42omo.forwardRef)(({ size: size = 'medium', src: src }, ref)=>{
    const dimension = $2b1b49e5891b6a04$var$sizeMap[size];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            height: `${dimension}px`,
            width: `${dimension}px`
        },
        ref: ref,
        className: (0, $gMc0m.default)([
            "_2rko1qll _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bfhksm61 _kqswh2mm"
        ]),
        children: src ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: src,
            alt: "",
            className: (0, $gMc0m.default)([
                "_4t3i1osq _1bsb1osq _5ral1dfr"
            ])
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            color: "var(--ds-icon-subtle, #505258)",
            label: "",
            spacing: "spacious"
        })
    });
});
$2b1b49e5891b6a04$var$Avatar.displayName = 'Avatar';
var $2b1b49e5891b6a04$export$2e2bcd8739ae039 = $2b1b49e5891b6a04$var$Avatar;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");

const $2668e0b020b006ad$var$styles = {
    root: "_12ji1r31 _1qu2glyw _12y31o36 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _vchhusvi _1bsb1osq _4cvr1y6m _bfhk1j28 _syaz1kw7 _zg8l4jg8 _k48pi7a9 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _y3gn1e5h",
    avatarItem: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozg12x7",
    baseText: "_1e0c1ule _syazi7uo",
    truncation: "_1reo15vq _1bto1l2s _o5721q9c"
};
const $2668e0b020b006ad$var$AvatarItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ avatar: avatar, primaryText: primaryText }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        ref: ref,
        className: (0, $gMc0m.default)([
            $2668e0b020b006ad$var$styles.root
        ]),
        children: [
            avatar,
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $2668e0b020b006ad$var$styles.avatarItem
                ]),
                children: (0, $dh538.fg)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        maxLines: 1,
                        children: primaryText
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        className: (0, $gMc0m.default)([
                            $2668e0b020b006ad$var$styles.baseText,
                            $2668e0b020b006ad$var$styles.truncation
                        ]),
                        children: primaryText
                    })
                })
            })
        ]
    });
});
$2668e0b020b006ad$var$AvatarItem.displayName = 'AvatarItem';
var $2668e0b020b006ad$export$2e2bcd8739ae039 = $2668e0b020b006ad$var$AvatarItem;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");




var $1s5hv = parcelRequire("1s5hv");



const $2001b5418a114de3$var$styles = {
    labelStyle: "_zulpze3t _1e0c1txw _1bsb53f4 _p12f53f4 _syazazsu _4cvr1y6m",
    valueStyle: "_zulp12x7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1y6m _syazi7uo _1i4qfg65 _1nmz1hna _1ul9idpf"
};
const $2001b5418a114de3$export$cc11f0bd89960b80 = ({ label: label, value: value })=>{
    if (value === null || value === undefined || value === '') return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($2001b5418a114de3$var$styles.labelStyle),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "inherit",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)($2001b5418a114de3$var$styles.valueStyle),
                children: value
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");











const $bc34a1071a91b692$var$styles = {
    rows: "_qgnu1l7x _1sw7nqa1 _7myae4h9 _1q51u2gc"
};
const $bc34a1071a91b692$export$cdc9f1a6e273987f = ({ title: title, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.050",
        role: "region",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    size: "large",
                    weight: "medium",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $bc34a1071a91b692$var$styles.rows,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                    space: "space.050",
                    children: children
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $2Nwuj = parcelRequire("2Nwuj");

const $28914610bb8ae377$var$messages = (0, $cgtv4.defineMessages)({
    userProfileValue: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.user-profile.row-value",
        defaultMessage: "Go to profile"
    }
});
const $28914610bb8ae377$export$fa6e42a58c4b579f = ({ profileUrl: profileUrl })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        href: profileUrl,
        target: "_blank",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$28914610bb8ae377$var$messages.userProfileValue
        })
    });
};





parcelRequire("42omo");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


const $eb9f3f34170e3fdb$export$ed090323b6f624d1 = (actor)=>{
    if (!actor?.email) return false;
    // If email does not contain @ sign, it's a system actor
    return !actor.email.includes('@');
};
const $eb9f3f34170e3fdb$var$defaultLogoAppearance = 'brand';
const $eb9f3f34170e3fdb$export$39846976078a8f0d = (actor)=>{
    if (!actor?.accountId) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2b1b49e5891b6a04$export$2e2bcd8739ae039), {
        size: "small",
        src: undefined
    });
    const actorId = actor.accountId.toLowerCase();
    let logo;
    switch(actorId){
        case 'atlassian-support':
            logo = /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                appearance: $eb9f3f34170e3fdb$var$defaultLogoAppearance,
                size: "small",
                shouldUseNewLogoDesign: true
            });
            break;
        case 'atlassian-internal-system':
            logo = /*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                appearance: $eb9f3f34170e3fdb$var$defaultLogoAppearance,
                size: "small",
                shouldUseNewLogoDesign: true
            });
            break;
        case 'opsgenie-user-service':
            logo = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.OpsgenieIcon), {
                appearance: $eb9f3f34170e3fdb$var$defaultLogoAppearance,
                size: "small",
                shouldUseNewLogoDesign: true
            });
            break;
        case 'jira':
            logo = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                appearance: $eb9f3f34170e3fdb$var$defaultLogoAppearance,
                size: "small",
                shouldUseNewLogoDesign: true
            });
            break;
        case 'confluence':
            logo = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
                appearance: $eb9f3f34170e3fdb$var$defaultLogoAppearance,
                size: "small",
                shouldUseNewLogoDesign: true
            });
            break;
        case 'anonymous':
        case 'unidentified':
        case 'idp':
            // Show avatar for anonymous, unidentified, and idp actors
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2b1b49e5891b6a04$export$2e2bcd8739ae039), {
                size: "small",
                src: undefined
            });
        default:
            // Default fallback for unknown system actors
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $2b1b49e5891b6a04$export$2e2bcd8739ae039), {
                size: "small",
                src: undefined
            });
    }
    return logo;
};


const $ed9e2365f9bbc15d$var$messages = (0, $cgtv4.defineMessages)({
    actor: {
        id: "organization.audit.log.side-panel.tab-panels.details.actor-section.title",
        defaultMessage: "Actor"
    },
    name: {
        id: "organization.audit.log.side-panel.tab-panels.details.actor-section.name.label",
        defaultMessage: "Name"
    },
    email: {
        id: "organization.audit.log.side-panel.tab-panels.details.actor-section.email.label",
        defaultMessage: "Email"
    },
    accountId: {
        id: "organization.audit.log.side-panel.tab-panels.details.actor-section.account-id.label",
        defaultMessage: "Account ID"
    },
    userProfile: {
        id: "organization.audit.log.side-panel.tab-panels.details.actor-section.user-profile.label",
        defaultMessage: "Details"
    }
});
const $ed9e2365f9bbc15d$export$3e61dbe089624cf5 = ({ actor: actor })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!actor) return null;
    const { name: name, avatarUrl: avatarUrl, email: email, accountId: accountId, profileLink: profileLink } = actor;
    // Determine if this is a system actor and get appropriate avatar content
    const isSystem = (0, $eb9f3f34170e3fdb$export$ed090323b6f624d1)(actor);
    const avatarContent = isSystem ? (0, $eb9f3f34170e3fdb$export$39846976078a8f0d)(actor) : /*#__PURE__*/ (0, $l998X.jsx)((0, $2b1b49e5891b6a04$export$2e2bcd8739ae039), {
        size: "small",
        src: avatarUrl
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($ed9e2365f9bbc15d$var$messages.actor),
        children: [
            name && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($ed9e2365f9bbc15d$var$messages.name),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $2668e0b020b006ad$export$2e2bcd8739ae039), {
                    primaryText: name,
                    avatar: avatarContent
                })
            }),
            email && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($ed9e2365f9bbc15d$var$messages.email),
                value: email
            }),
            accountId && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($ed9e2365f9bbc15d$var$messages.accountId),
                value: accountId
            }),
            profileLink && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($ed9e2365f9bbc15d$var$messages.userProfile),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $28914610bb8ae377$export$fa6e42a58c4b579f), {
                    profileUrl: profileLink
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");













const $1e23f741feec8dcd$var$valueStyles = {
    oldValue: "_1e0c1nu9 _bfhk1vk5",
    oldValueText: "_1hms1911",
    newValue: "_1e0c1nu9 _bfhkn729"
};
const $1e23f741feec8dcd$var$messages = (0, $cgtv4.defineMessages)({
    changeComparison: {
        id: "organization.audit.log.side-panel.tab-panels.details.change-comparison-section.title",
        defaultMessage: "Change comparison"
    },
    oldValue: {
        id: "organization.audit.log.side-panel.tab-panels.details.change-comparison-section.old-value.label",
        defaultMessage: "Previous value"
    },
    newValue: {
        id: "organization.audit.log.side-panel.tab-panels.details.change-comparison-section.new-value.label",
        defaultMessage: "New value"
    }
});
const $1e23f741feec8dcd$export$d3de79af833e83ab = ({ event: event })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!event || !event.oldValue && !event.newValue) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($1e23f741feec8dcd$var$messages.changeComparison),
        children: [
            event.oldValue !== undefined && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($1e23f741feec8dcd$var$messages.oldValue),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        xcss: $1e23f741feec8dcd$var$valueStyles.oldValueText,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $1e23f741feec8dcd$var$valueStyles.oldValue,
                            children: event.oldValue
                        })
                    })
                })
            }),
            event.newValue !== undefined && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($1e23f741feec8dcd$var$messages.newValue),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    as: "span",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $1e23f741feec8dcd$var$valueStyles.newValue,
                            children: event.newValue
                        })
                    })
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








const $00e41aae60cb5cf9$var$messages = (0, $cgtv4.defineMessages)({
    location: {
        id: "organization.audit.log.side-panel.tab-panels.details.location-section.title",
        defaultMessage: "Location"
    },
    city: {
        id: "organization.audit.log.side-panel.tab-panels.details.location-section.city.label",
        defaultMessage: "City"
    },
    ipAddress: {
        id: "organization.audit.log.side-panel.tab-panels.details.location-section.ip-address.label",
        defaultMessage: "IP address"
    },
    region: {
        id: "organization.audit.log.side-panel.tab-panels.details.location-section.region.label",
        defaultMessage: "Region"
    },
    country: {
        id: "organization.audit.log.side-panel.tab-panels.details.location-section.country.label",
        defaultMessage: "Country"
    }
});
const $00e41aae60cb5cf9$export$1ad27273b2411f42 = ({ location: location })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!location) return null;
    const { city: city, ip: ip, regionName: regionName, countryName: countryName } = location;
    if (!city && !ip && !regionName && !countryName) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($00e41aae60cb5cf9$var$messages.location),
        children: [
            ip && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($00e41aae60cb5cf9$var$messages.ipAddress),
                value: ip
            }),
            city && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($00e41aae60cb5cf9$var$messages.city),
                value: city
            }),
            regionName && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($00e41aae60cb5cf9$var$messages.region),
                value: regionName
            }),
            countryName && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($00e41aae60cb5cf9$var$messages.country),
                value: countryName
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $67O0h = parcelRequire("67O0h");

// so we need to style it manually
const $7a58b53ce347153c$var$activityMessageContainerStyle = null;
const $7a58b53ce347153c$var$ActivityParagraphStyle = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_11c8fhey"
        ]),
        children: children
    });
const $7a58b53ce347153c$var$activityStyles = {
    paragraph: $7a58b53ce347153c$var$ActivityParagraphStyle
};
const $7a58b53ce347153c$export$64f87d9f80f55ab = ({ activity: activity })=>{
    if (activity === undefined || activity?.message === undefined) return null;
    if (activity.type === 'adf') {
        const activityDocument = JSON.parse(activity.message);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
            document: activityDocument,
            nodeComponents: $7a58b53ce347153c$var$activityStyles
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: activity.message
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $cvXh8 = parcelRequire("cvXh8");


var $2MuFw = parcelRequire("2MuFw");





var $3gadb = parcelRequire("3gadb");

const $38d64992426693d5$var$RESET_DELAY = 2000;
const $38d64992426693d5$var$messages = (0, $cgtv4.defineMessages)({
    copy: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.json-value.row-value.button",
        defaultMessage: "Copy"
    },
    copied: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.json-value.row-value",
        defaultMessage: "Copied!"
    },
    copyTooltip: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.copyReadyTooltip.row-value.button",
        defaultMessage: "Copy to clipboard"
    },
    copySuccessTooltip: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.copySuccessTooltip.row-value.button",
        defaultMessage: "Copied!"
    },
    copyFailedTooltip: {
        id: "organization.audit.log.side-panel.tab-panels.details.sub-section.copyFailedTooltip.row-value.button",
        defaultMessage: "Copy event JSON failed"
    }
});
var $38d64992426693d5$var$CopyState = /*#__PURE__*/ function(CopyState) {
    CopyState["READY"] = "READY";
    CopyState["COPIED"] = "COPIED";
    CopyState["FAILED"] = "FAILED";
    return CopyState;
}($38d64992426693d5$var$CopyState || {});
const $38d64992426693d5$export$7de8f2c2f2f9149d = ({ eventJSON: eventJSON })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state, setState] = (0, $42omo.useState)("READY");
    const handleCopy = (0, $42omo.useCallback)(async ()=>{
        try {
            await navigator.clipboard.writeText(eventJSON);
            setState("COPIED");
        } catch  {
            setState("FAILED");
        }
        setTimeout(()=>setState("READY"), $38d64992426693d5$var$RESET_DELAY);
    }, [
        eventJSON
    ]);
    const getIcon = ()=>{
        switch(state){
            case "COPIED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($cvXh8));
            case "FAILED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($a3fRD));
            default:
                return 0, (/*@__PURE__*/$parcel$interopDefault($2MuFw));
        }
    };
    const getTooltipContent = ()=>{
        switch(state){
            case "COPIED":
                return formatMessage($38d64992426693d5$var$messages.copySuccessTooltip);
            case "FAILED":
                return formatMessage($38d64992426693d5$var$messages.copyFailedTooltip);
            default:
                return formatMessage($38d64992426693d5$var$messages.copyTooltip);
        }
    };
    const getButtonText = ()=>{
        return state === "COPIED" ? $38d64992426693d5$var$messages.copied : $38d64992426693d5$var$messages.copy;
    };
    const IconComponent = getIcon();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: getTooltipContent(),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            testId: `copy-button-${state}`,
            iconAfter: IconComponent,
            onClick: handleCopy,
            spacing: "compact",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...getButtonText()
            })
        })
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $83214f51300513b7$export$bf94a074d6f65d2a = ({ timestamp: timestamp })=>{
    if (!timestamp) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        value: timestamp,
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        timeZoneName: "short"
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");



const $a5e5d4b9423335fc$export$77fc3e7c6375c538 = ({ title: title, rows: rows })=>{
    if (!rows || rows.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: title,
        children: rows.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: label,
                value: value
            }, label))
    });
};


const $e149b1e2606a76ea$var$messages = (0, $cgtv4.defineMessages)({
    summary: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.title",
        defaultMessage: "Summary"
    },
    category: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.category.label",
        defaultMessage: "Category"
    },
    activity: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.activity.label",
        defaultMessage: "Activity"
    },
    action: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.action.label",
        defaultMessage: "Action"
    },
    type: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.type.label",
        defaultMessage: "Type"
    },
    activityId: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.activity-id.label",
        defaultMessage: "Activity ID"
    },
    date: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.date.label",
        defaultMessage: "Date"
    },
    json: {
        id: "organization.audit.log.side-panel.tab-panels.details.summary-section.json.label",
        defaultMessage: "JSON"
    }
});
const $e149b1e2606a76ea$export$77fc3e7c6375c538 = ({ event: event })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!event || !event.details) return null;
    const { activity: activity, action: action, type: type, activityId: activityId, date: date, category: category } = event.details;
    const rows = [];
    if (activity && activity.message) rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.activity),
        value: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a58b53ce347153c$export$64f87d9f80f55ab), {
            activity: activity
        })
    });
    if (category) rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.category),
        value: category
    });
    rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.action),
        value: action
    });
    rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.type),
        value: type
    });
    rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.activityId),
        value: activityId
    });
    if (date) rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.date),
        value: /*#__PURE__*/ (0, $l998X.jsx)((0, $83214f51300513b7$export$bf94a074d6f65d2a), {
            timestamp: date
        })
    });
    rows.push({
        label: formatMessage($e149b1e2606a76ea$var$messages.json),
        value: /*#__PURE__*/ (0, $l998X.jsx)((0, $38d64992426693d5$export$7de8f2c2f2f9149d), {
            eventJSON: JSON.stringify(event)
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a5e5d4b9423335fc$export$77fc3e7c6375c538), {
        title: formatMessage($e149b1e2606a76ea$var$messages.summary),
        rows: rows
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 























const $eab4a4c249cd6c5d$var$RESET_DELAY = 2000;
var $eab4a4c249cd6c5d$var$CopyState = /*#__PURE__*/ function(CopyState) {
    CopyState["READY"] = "READY";
    CopyState["COPIED"] = "COPIED";
    CopyState["FAILED"] = "FAILED";
    return CopyState;
}($eab4a4c249cd6c5d$var$CopyState || {});
const $eab4a4c249cd6c5d$export$4f2558dd25106ae2 = ({ unitId: unitId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state, setState] = (0, $42omo.useState)("READY");
    const handleCopy = (0, $42omo.useCallback)(async ()=>{
        if (!unitId) return;
        try {
            await navigator.clipboard.writeText(unitId);
            setState("COPIED");
        } catch  {
            setState("FAILED");
        }
        setTimeout(()=>setState("READY"), $eab4a4c249cd6c5d$var$RESET_DELAY);
    }, [
        unitId
    ]);
    const getIcon = ()=>{
        switch(state){
            case "COPIED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($cvXh8));
            case "FAILED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($a3fRD));
            default:
                return 0, (/*@__PURE__*/$parcel$interopDefault($2MuFw));
        }
    };
    const getTooltipContent = ()=>{
        switch(state){
            case "COPIED":
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-id.copySuccessTooltip",
                    defaultMessage: "Copied!"
                });
            case "FAILED":
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-id.copyFailedTooltip",
                    defaultMessage: "Copy failed"
                });
            default:
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-id.copyTooltip",
                    defaultMessage: "Copy to clipboard"
                });
        }
    };
    const IconComponent = getIcon();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: getTooltipContent(),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            testId: `copy-unit-id-button-${state}`,
            icon: IconComponent,
            onClick: handleCopy,
            spacing: "compact",
            isDisabled: !unitId,
            label: getTooltipContent(),
            appearance: "subtle"
        })
    });
};


const $45cc373e78ffe2f3$export$c6565bbb8dfaa780 = ({ unitId: unitId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        alignItems: "start",
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtle",
                weight: "regular",
                as: "p",
                size: "medium",
                children: unitId
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eab4a4c249cd6c5d$export$4f2558dd25106ae2), {
                unitId: unitId
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









const $853c1e51c884ac1b$var$messages = (0, $cgtv4.defineMessages)({
    unitProfileValue: {
        id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-profile.row-value",
        defaultMessage: "Go to profile"
    }
});
const $853c1e51c884ac1b$export$c54558f33766c9bf = ({ profileUrl: profileUrl })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
        href: profileUrl,
        target: "_blank",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...$853c1e51c884ac1b$var$messages.unitProfileValue
        })
    });
};


const $6537e59e1933c590$var$messages = (0, $cgtv4.defineMessages)({
    unit: {
        id: "organization.audit.log.side-panel.tab-panels.details.unit-section.title",
        defaultMessage: "Unit"
    },
    name: {
        id: "organization.audit.log.side-panel.tab-panels.details.unit-section.name.label",
        defaultMessage: "Name"
    },
    unitId: {
        id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-id.label",
        defaultMessage: "Unit ID"
    },
    unitProfile: {
        id: "organization.audit.log.side-panel.tab-panels.details.unit-section.unit-profile.label",
        defaultMessage: "Unit profile"
    }
});
const $6537e59e1933c590$export$baba40f1292d997b = ({ unit: unit })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!unit) return null;
    const { name: name, id: id, profile: profile } = unit;
    if (!name && !id && !profile) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($6537e59e1933c590$var$messages.unit),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($6537e59e1933c590$var$messages.name),
                value: name
            }),
            id && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($6537e59e1933c590$var$messages.unitId),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $45cc373e78ffe2f3$export$c6565bbb8dfaa780), {
                    unitId: id
                })
            }),
            profile && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($6537e59e1933c590$var$messages.unitProfile),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $853c1e51c884ac1b$export$c54558f33766c9bf), {
                    profileUrl: profile
                })
            })
        ]
    });
};


const $1c9894575237c043$export$e54a7f2505304e20 = ({ event: event })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e149b1e2606a76ea$export$77fc3e7c6375c538), {
                event: event
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ed9e2365f9bbc15d$export$3e61dbe089624cf5), {
                actor: event?.actor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $00e41aae60cb5cf9$export$1ad27273b2411f42), {
                location: event?.location
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6537e59e1933c590$export$baba40f1292d997b), {
                unit: event?.unit
            }),
            event?.oldValue !== undefined && event?.newValue !== undefined && /*#__PURE__*/ (0, $l998X.jsx)((0, $1e23f741feec8dcd$export$d3de79af833e83ab), {
                event: event
            })
        ]
    });
};









var $9QfXi = parcelRequire("9QfXi");

const $0a79dee7547e3a99$export$ad9771ffede2a20a = ({ event: event, eventJson: eventJson })=>{
    const displayJson = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (event?.rawEvent) return JSON.stringify(event.rawEvent, null, 1);
        if (eventJson) try {
            // Parse and re-stringify with formatting to match event.rawEvent style
            return JSON.stringify(JSON.parse(eventJson), null, 1);
        } catch  {
            // If parsing fails, return as-is
            return eventJson;
        }
        return '';
    }, [
        event?.rawEvent,
        eventJson
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9QfXi.default), {
        language: "json",
        text: displayJson,
        shouldWrapLongLines: true
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








const $a72b088b4ee0fecc$var$messages = (0, $cgtv4.defineMessages)({
    filtersApplied: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.title",
        defaultMessage: "Filters applied"
    },
    date: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.date.label",
        defaultMessage: "Date"
    },
    activity: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.activity.label",
        defaultMessage: "Activity"
    },
    actor: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.actor.label",
        defaultMessage: "Actor"
    },
    ipAddress: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.ip-address.label",
        defaultMessage: "IP Address"
    },
    location: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.location.label",
        defaultMessage: "Location"
    },
    app: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.app.label",
        defaultMessage: "App"
    },
    relatedActivities: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.filters-section.related-activities.label",
        defaultMessage: "Related activities"
    }
});
const $a72b088b4ee0fecc$export$a676fe2c1c570ad2 = ({ filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!filters) return null;
    const { event_time: event_time, activity: activity, actors: actors, ips: ips, location: location, app: app, related_activities: related_activities } = filters;
    // Check if any filter is present with non-empty values
    const hasFilters = event_time || activity && activity.length > 0 || actors && actors.length > 0 || ips && ips.length > 0 || location && location.length > 0 || app && app.length > 0 || related_activities && related_activities.length > 0;
    if (!hasFilters) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($a72b088b4ee0fecc$var$messages.filtersApplied),
        children: [
            event_time && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.date),
                value: `${event_time.from} - ${event_time.to}`
            }),
            activity && activity.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.activity),
                value: activity.join(', ')
            }),
            actors && actors.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.actor),
                value: actors.join(', ')
            }),
            ips && ips.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.ipAddress),
                value: ips.join(', ')
            }),
            location && location.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.location),
                value: location.join(', ')
            }),
            app && app.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.app),
                value: app.join(', ')
            }),
            related_activities && related_activities.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
                label: formatMessage($a72b088b4ee0fecc$var$messages.relatedActivities),
                value: related_activities.join(', ')
            })
        ]
    });
};





parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");

const $33c66918aea3a129$var$getLozengeAppearance = (status)=>{
    switch(status){
        case 'COMPLETED':
            return 'success';
        case 'QUEUED':
            return 'moved';
        case 'FAILED':
            return 'removed';
        case 'IN_PROGRESS':
            return 'inprogress';
        case 'ABORTED':
            return undefined;
        default:
            return undefined;
    }
};
const $33c66918aea3a129$var$getStatusLabel = (status)=>{
    switch(status){
        case 'COMPLETED':
            return 'Completed';
        case 'QUEUED':
            return 'Queued';
        case 'FAILED':
            return 'Failed';
        case 'IN_PROGRESS':
            return 'In Progress';
        case 'ABORTED':
            return 'Aborted';
        default:
            return 'Unknown';
    }
};
const $33c66918aea3a129$export$4fb24bf488f7b450 = ({ status: status })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
        appearance: $33c66918aea3a129$var$getLozengeAppearance(status),
        isBold: true,
        children: $33c66918aea3a129$var$getStatusLabel(status)
    });


const $5c3f8a8050c2888e$var$messages = (0, $cgtv4.defineMessages)({
    summary: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.title",
        defaultMessage: "Summary"
    },
    name: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.name.label",
        defaultMessage: "Name"
    },
    description: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.description.label",
        defaultMessage: "Description"
    },
    status: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.status.label",
        defaultMessage: "Status"
    },
    createdAt: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.created-at.label",
        defaultMessage: "Created"
    },
    updatedAt: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.updated-at.label",
        defaultMessage: "Completed"
    },
    createdBy: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.created-by.label",
        defaultMessage: "Created By"
    },
    id: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.id.label",
        defaultMessage: "Query ID"
    },
    json: {
        id: "organization.audit.log.side-panel.tab-panels.query-details.summary-section.json.label",
        defaultMessage: "JSON"
    }
});
const $5c3f8a8050c2888e$export$81883f52ec75f685 = ({ queryData: queryData })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!queryData) return null;
    const { name: name, description: description, status: status, createdAt: createdAt, updatedAt: updatedAt, createdBy: createdBy, id: id } = queryData;
    const rows = [
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.name),
            value: name
        },
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.description),
            value: description
        },
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.id),
            value: id
        },
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.status),
            value: /*#__PURE__*/ (0, $l998X.jsx)((0, $33c66918aea3a129$export$4fb24bf488f7b450), {
                status: status
            })
        },
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.createdAt),
            value: /*#__PURE__*/ (0, $l998X.jsx)((0, $83214f51300513b7$export$bf94a074d6f65d2a), {
                timestamp: createdAt
            })
        },
        ...status === 'COMPLETED' && updatedAt ? [
            {
                label: formatMessage($5c3f8a8050c2888e$var$messages.updatedAt),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $83214f51300513b7$export$bf94a074d6f65d2a), {
                    timestamp: updatedAt
                })
            }
        ] : [],
        ...createdBy?.name ? [
            {
                label: formatMessage($5c3f8a8050c2888e$var$messages.createdBy),
                value: /*#__PURE__*/ (0, $l998X.jsx)((0, $2668e0b020b006ad$export$2e2bcd8739ae039), {
                    primaryText: createdBy.name,
                    avatar: /*#__PURE__*/ (0, $l998X.jsx)((0, $2b1b49e5891b6a04$export$2e2bcd8739ae039), {
                        size: "small",
                        src: createdBy.avatarUrl
                    })
                })
            }
        ] : [],
        {
            label: formatMessage($5c3f8a8050c2888e$var$messages.json),
            value: /*#__PURE__*/ (0, $l998X.jsx)((0, $38d64992426693d5$export$7de8f2c2f2f9149d), {
                eventJSON: JSON.stringify(queryData)
            })
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.300",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a5e5d4b9423335fc$export$77fc3e7c6375c538), {
                title: formatMessage($5c3f8a8050c2888e$var$messages.summary),
                rows: rows
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a72b088b4ee0fecc$export$a676fe2c1c570ad2), {
                filters: queryData.filters
            })
        ]
    });
};





parcelRequire("42omo");
















parcelRequire("42omo");





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $esRft = parcelRequire("esRft");













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");









const $58dc50b163065e34$export$d9bcbd5e1ff81430 = ({ timestamp: timestamp })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtle",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
                    value: timestamp,
                    year: "numeric",
                    month: "short",
                    day: "2-digit"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtlest",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedTime), {
                    value: timestamp,
                    hourCycle: "h23",
                    hour: "numeric",
                    minute: "numeric",
                    timeZoneName: "shortOffset"
                })
            })
        ]
    });
};


const $f5497c6bfc7b8ef5$var$styles = {
    labelStyle: "_1ul968cl",
    valueStyle: "_1nmz1hna",
    rows: "_1q51u2gc _85i5u2gc _1ezz1l7x _12ornqa1 _1r62e4h9"
};
const $f5497c6bfc7b8ef5$export$15cfbb4156e65a89 = ({ timestamp: timestamp, activity: activity, avatarUrl: avatarUrl })=>{
    if (activity === null || activity === undefined || activity === '' || !timestamp) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        xcss: $f5497c6bfc7b8ef5$var$styles.rows,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "start",
            gap: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($f5497c6bfc7b8ef5$var$styles.labelStyle),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $58dc50b163065e34$export$d9bcbd5e1ff81430), {
                        timestamp: timestamp
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    space: "space.075",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                            size: "medium",
                            src: avatarUrl
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($f5497c6bfc7b8ef5$var$styles.valueStyle),
                            children: activity
                        })
                    ]
                })
            ]
        })
    });
};


const $fba3971d5749737d$export$26fa611b766358af = ({ relatedEvents: relatedEvents })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.050",
        children: relatedEvents.map((event)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f5497c6bfc7b8ef5$export$15cfbb4156e65a89), {
                timestamp: event.timestamp,
                activity: /*#__PURE__*/ (0, $l998X.jsx)((0, $7a58b53ce347153c$export$64f87d9f80f55ab), {
                    activity: event.activity
                }),
                avatarUrl: event.avatarUrl
            }, event.eventId))
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");
















const $fc23acb7f9b89e68$var$styles = {
    container: "_1rjcu2gc"
};
const $fc23acb7f9b89e68$var$messages = (0, $cgtv4.defineMessages)({
    tableFooterResults: {
        id: "organization.audit.log.side-panel.tabs.related-activities.table.footer.results",
        defaultMessage: "1-{numOfDisplayedEvents} of {totalEvents} results"
    },
    goToRelatedLink: {
        id: "organization.audit.log.side-panel.tabs.related-activities.table.footer.go-to-related.link",
        defaultMessage: "See all related activities"
    }
});
const $fc23acb7f9b89e68$export$1f116082bba1f9a8 = ({ displayedEventsCount: displayedEventsCount, totalEventsCount: totalEventsCount, hasMoreEvents: hasMoreEvents, relatedEventsLink: relatedEventsLink })=>{
    if (displayedEventsCount === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {});
    const relatedEventsTotal = totalEventsCount + (hasMoreEvents ? '+' : '');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $fc23acb7f9b89e68$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...$fc23acb7f9b89e68$var$messages.tableFooterResults,
                        values: {
                            numOfDisplayedEvents: displayedEventsCount,
                            totalEvents: relatedEventsTotal
                        }
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: relatedEventsLink,
                    target: "_blank",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...$fc23acb7f9b89e68$var$messages.goToRelatedLink
                    })
                })
            ]
        })
    });
};





parcelRequire("42omo");













/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 























const $169e9cf9ebdae7af$var$RESET_DELAY = 2000;
var $169e9cf9ebdae7af$var$CopyState = /*#__PURE__*/ function(CopyState) {
    CopyState["READY"] = "READY";
    CopyState["COPIED"] = "COPIED";
    CopyState["FAILED"] = "FAILED";
    return CopyState;
}($169e9cf9ebdae7af$var$CopyState || {});
const $169e9cf9ebdae7af$export$d1da938e3a7df93b = ({ correlationId: correlationId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state, setState] = (0, $42omo.useState)("READY");
    const handleCopy = (0, $42omo.useCallback)(async ()=>{
        if (!correlationId) return;
        try {
            await navigator.clipboard.writeText(correlationId);
            setState("COPIED");
        } catch  {
            setState("FAILED");
        }
        setTimeout(()=>setState("READY"), $169e9cf9ebdae7af$var$RESET_DELAY);
    }, [
        correlationId
    ]);
    const getIcon = ()=>{
        switch(state){
            case "COPIED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($cvXh8));
            case "FAILED":
                return 0, (/*@__PURE__*/$parcel$interopDefault($a3fRD));
            default:
                return 0, (/*@__PURE__*/$parcel$interopDefault($2MuFw));
        }
    };
    const getTooltipContent = ()=>{
        switch(state){
            case "COPIED":
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.related-activities.table-header.copySuccessTooltip",
                    defaultMessage: "Copied!"
                });
            case "FAILED":
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.related-activities.table-header.copyFailedTooltip",
                    defaultMessage: "Copy failed"
                });
            default:
                return formatMessage({
                    id: "organization.audit.log.side-panel.tab-panels.related-activities.table-header.copyTooltip",
                    defaultMessage: "Copy to clipboard"
                });
        }
    };
    const IconComponent = getIcon();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: getTooltipContent(),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            testId: `copy-correlation-id-button-${state}`,
            icon: IconComponent,
            onClick: handleCopy,
            spacing: "compact",
            isDisabled: !correlationId,
            label: getTooltipContent(),
            appearance: "subtle"
        })
    });
};


const $2daae21b328fd265$var$messages = (0, $cgtv4.defineMessages)({
    summary: {
        id: "organization.audit.log.side-panel.tab-panels.related-activities.summary-section.title",
        defaultMessage: "Summary"
    },
    correlationId: {
        id: "organization.audit.log.side-panel.tab-panels.related-activities.summary-section.correlation-id.label",
        defaultMessage: "Correlation ID"
    }
});
const $2daae21b328fd265$var$correlationIdComponent = (correlationId)=>{
    if (!correlationId) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        alignItems: "start",
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtle",
                weight: "regular",
                as: "p",
                size: "medium",
                children: correlationId
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $169e9cf9ebdae7af$export$d1da938e3a7df93b), {
                correlationId: correlationId
            })
        ]
    });
};
const $2daae21b328fd265$export$f850895b287ef28e = ({ correlationId: correlationId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
        title: formatMessage($2daae21b328fd265$var$messages.summary),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2001b5418a114de3$export$cc11f0bd89960b80), {
            label: formatMessage($2daae21b328fd265$var$messages.correlationId),
            value: $2daae21b328fd265$var$correlationIdComponent(correlationId)
        })
    });
};


const $f39e7f22f2f5e341$var$messages = (0, $cgtv4.defineMessages)({
    relatedActivities: {
        id: "organization.audit.log.side-panel.tab-panels.related-activities.related-activities-section.title",
        defaultMessage: "Related activities"
    }
});
const $f39e7f22f2f5e341$export$903fa9d2c3074624 = ({ relatedEvents: relatedEvents })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const displayedEvents = relatedEvents.relatedEvents.slice(0, (0, $8d20c6f1a7e0646a$export$2e839de1f68a7db));
    const displayedEventsCount = displayedEvents.length;
    if (displayedEventsCount === 0) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {});
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.300",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2daae21b328fd265$export$f850895b287ef28e), {
                        correlationId: relatedEvents.correlationId
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bc34a1071a91b692$export$cdc9f1a6e273987f), {
                        title: formatMessage($f39e7f22f2f5e341$var$messages.relatedActivities),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fba3971d5749737d$export$26fa611b766358af), {
                            relatedEvents: displayedEvents
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fc23acb7f9b89e68$export$1f116082bba1f9a8), {
                displayedEventsCount: displayedEventsCount,
                totalEventsCount: relatedEvents.totalEventsCount,
                hasMoreEvents: relatedEvents.hasMoreEvents,
                relatedEventsLink: relatedEvents.relatedEventsLink ?? ''
            })
        ]
    });
};


const $e4b375e3823ba65f$var$styles = {
    noDoubleScroll: "_kqswh2mm",
    tabPanelContent: "_ca0qpxbi"
}; // ----- Internal View Component (uses controller context) -----
const $e4b375e3823ba65f$var$SidePanelView = ()=>{
    const { state: panel, dispatch: dispatch } = (0, $ef8cda562a155a20$export$295bd9db651c4ee1)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!panel) return null;
    const handleClose = ()=>dispatch({
            type: 'CLOSE'
        }); // Activity Details Mode
    if (panel.mode === 'activity-details') {
        const shouldShowRelatedActivitiesTab = !!panel.relatedEvents.correlationId;
        const activityTabs = shouldShowRelatedActivitiesTab ? [
            'details',
            'related-activities',
            'json'
        ] : [
            'details',
            'json'
        ];
        const tabIndex = activityTabs.indexOf(panel.activeTab);
        const handleActivityTabChange = (index)=>{
            const tab = activityTabs[index];
            dispatch({
                type: 'SET_TAB',
                tab: tab
            });
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f3e94988e3352fc$export$2e2bcd8739ae039), {
            title: formatMessage((0, $9b7393aed24d92c3$export$defe85febe8b728c).inspectViewTitle),
            onClose: handleClose,
            mainContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $e4b375e3823ba65f$var$styles.noDoubleScroll,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4A7Gn.default), {
                    id: "activity-details-tabs",
                    selected: tabIndex,
                    onChange: handleActivityTabChange,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $9b7393aed24d92c3$export$defe85febe8b728c).detailsTab
                                    })
                                }),
                                shouldShowRelatedActivitiesTab && /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eda102eb815ab2b6$export$745595d7b646149b), {
                                        isLoading: panel.relatedEvents.isLoading,
                                        hasError: panel.relatedEvents.hasError,
                                        hasMoreEvents: panel.relatedEvents.hasMoreEvents,
                                        totalEventsCount: panel.relatedEvents.totalEventsCount,
                                        isSelected: panel.activeTab === 'related-activities'
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $9b7393aed24d92c3$export$defe85febe8b728c).jsonTab
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $e4b375e3823ba65f$var$styles.tabPanelContent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1c9894575237c043$export$e54a7f2505304e20), {
                                    event: panel.activityData
                                })
                            })
                        }),
                        shouldShowRelatedActivitiesTab && /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $e4b375e3823ba65f$var$styles.tabPanelContent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f39e7f22f2f5e341$export$903fa9d2c3074624), {
                                    relatedEvents: panel.relatedEvents
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $e4b375e3823ba65f$var$styles.tabPanelContent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0a79dee7547e3a99$export$ad9771ffede2a20a), {
                                    event: panel.activityData,
                                    eventJson: JSON.stringify(panel.activityData, null, 2)
                                })
                            })
                        })
                    ]
                })
            })
        });
    }
    // Query Details Mode (panel.mode === 'query-details')
    const queryTabs = [
        'query-details',
        'example-second-tab'
    ];
    const queryTabIndex = queryTabs.indexOf(panel.activeTab);
    const handleQueryTabChange = (index)=>{
        const tab = queryTabs[index];
        dispatch({
            type: 'SET_TAB',
            tab: tab
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f3e94988e3352fc$export$2e2bcd8739ae039), {
        title: formatMessage((0, $9b7393aed24d92c3$export$defe85febe8b728c).inspectViewTitle),
        onClose: handleClose,
        mainContent: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $e4b375e3823ba65f$var$styles.noDoubleScroll,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $4A7Gn.default), {
                id: "query-details-tabs",
                selected: queryTabIndex,
                onChange: handleQueryTabChange,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $0DTaW.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $9b7393aed24d92c3$export$defe85febe8b728c).queryDetailsTab
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gCbPZ.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $9b7393aed24d92c3$export$defe85febe8b728c).jsonTab
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $e4b375e3823ba65f$var$styles.tabPanelContent,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5c3f8a8050c2888e$export$81883f52ec75f685), {
                                queryData: panel.queryData
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $d2kvf.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $e4b375e3823ba65f$var$styles.tabPanelContent,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0a79dee7547e3a99$export$ad9771ffede2a20a), {
                                eventJson: JSON.stringify(panel.queryData)
                            })
                        })
                    })
                ]
            })
        })
    });
};
// ----- Main Component (manages state and provides controller) -----
const $e4b375e3823ba65f$var$AuditLogsSidePanelComponent = ({ sidePanel: sidePanel, onClose: onClose, onTabChange: onTabChange })=>{
    const { activeMode: activeMode, activity: activity, query: query } = sidePanel; // Derive the mode for internal state
    const mode = activeMode === 'activity' ? 'activity-details' : 'query-details'; // Default tab values when configs are not provided
    const activityActiveTab = activity?.activeTab ?? 'details';
    const queryActiveTab = query?.activeTab ?? 'query-details'; // Build panel state from structured props
    const [panelState, setPanelState] = (0, $42omo.useState)(()=>{
        if (mode === 'query-details' && query) return {
            mode: 'query-details',
            queryData: query.queryData,
            activeTab: queryActiveTab,
            tabHistory: {
                'activity-details': activityActiveTab,
                'query-details': queryActiveTab
            }
        };
        if (mode === 'activity-details' && activity) return {
            mode: 'activity-details',
            activityData: activity.activityData,
            relatedEvents: activity.relatedEvents,
            activeTab: activityActiveTab,
            tabHistory: {
                'activity-details': activityActiveTab,
                'query-details': queryActiveTab
            }
        };
         // No matching config for the active mode
        return null;
    }); // Sync panel state when props change (mode switch, tab change, data change)
    (0, $42omo.useEffect)(()=>{
        if (mode === 'query-details' && query) setPanelState({
            mode: 'query-details',
            queryData: query.queryData,
            activeTab: queryActiveTab,
            tabHistory: {
                'activity-details': activityActiveTab,
                'query-details': queryActiveTab
            }
        });
        else if (mode === 'activity-details' && activity) setPanelState({
            mode: 'activity-details',
            activityData: activity.activityData,
            relatedEvents: activity.relatedEvents,
            activeTab: activityActiveTab,
            tabHistory: {
                'activity-details': activityActiveTab,
                'query-details': queryActiveTab
            }
        });
        else setPanelState(null);
    }, [
        mode,
        activity,
        activityActiveTab,
        query,
        queryActiveTab
    ]); // External actions (owned by this component)
    const actions = {
        setActivityTab: (tab)=>{
            setPanelState((prev)=>prev && prev.mode === 'activity-details' ? {
                    ...prev,
                    activeTab: tab
                } : prev);
            if (onTabChange) onTabChange(tab);
        },
        setQueryTab: (tab)=>{
            setPanelState((prev)=>prev && prev.mode === 'query-details' ? {
                    ...prev,
                    activeTab: tab
                } : prev);
            if (onTabChange) onTabChange(tab);
        },
        onClose: ()=>{
            if (onClose) // Parent controls visibility — just notify
            onClose();
            else // No external handler — fallback to internal state management
            setPanelState(null);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fd82250eef85a420$export$bc8d97f89653bd3a), {
        state: panelState,
        actions: actions,
        children: /*#__PURE__*/ (0, $l998X.jsx)($e4b375e3823ba65f$var$SidePanelView, {})
    });
};
const $e4b375e3823ba65f$export$9c5f261b71e68b6d = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: ()=>Promise.resolve({}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($e4b375e3823ba65f$var$AuditLogsSidePanelComponent, {
            ...props
        })
    });



var $aXWtB = parcelRequire("aXWtB");


var $5qqdA = parcelRequire("5qqdA");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jmjWc = parcelRequire("jmjWc");


const $d70f760b84e45474$export$f5043157c1558e39 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g2Qgf",
    name: "HelpPanel",
    loader: async ()=>(await (parcelRequire("jcxYP"))).HelpPanel
});



var $cLgYq = parcelRequire("cLgYq");


var $14QAi = parcelRequire("14QAi");


var $dIDyF = parcelRequire("dIDyF");


var $jln20 = parcelRequire("jln20");


var $7zgzO = parcelRequire("7zgzO");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $bQm3c = parcelRequire("bQm3c");


var $UNr39 = parcelRequire("UNr39");


var $aiS08 = parcelRequire("aiS08");


var $9wGTI = parcelRequire("9wGTI");

parcelRequire("c2IXc");
var $7F52Q = parcelRequire("7F52Q");


var $1vpkQ = parcelRequire("1vpkQ");

// Common Component Audit Log Side Panel
const $dc07a4d102f2ddf8$var$AuditLogDetailsPanel = ()=>{
    const $ = (0, $frIzR.c)(10);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $7F52Q.getAuditLogEvent)();
        $[0] = t0;
    } else t0 = $[0];
    const selectedEvent = t0;
    let t1;
    if ($[1] !== rightSidebarContext) {
        t1 = ()=>{
            (0, $7F52Q.clearAuditLogEvent)();
            rightSidebarContext.close((0, $7F52Q.AUDIT_LOG_DETAILS_PANEL));
        };
        $[1] = rightSidebarContext;
        $[2] = t1;
    } else t1 = $[2];
    const handleClose = t1;
    if (!selectedEvent) return null;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            name: selectedEvent.attributes?.actor?.name || "",
            email: selectedEvent.attributes?.actor?.email || "",
            accountId: selectedEvent.attributes?.actor?.id || "",
            avatarUrl: selectedEvent.attributes?.actor?.picture || ""
        };
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            action: selectedEvent.attributes?.action || "",
            activityId: selectedEvent.id || "",
            date: selectedEvent.attributes?.time || "",
            category: "audit",
            activity: {
                message: selectedEvent.message?.content || "",
                type: selectedEvent.message?.format || "simple"
            }
        };
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            actor: t2,
            details: t3,
            location: {
                ip: selectedEvent.attributes?.location?.ip || "",
                city: selectedEvent.attributes?.location?.city || ""
            }
        };
        $[5] = t4;
    } else t4 = $[5];
    const transformedEvent = t4;
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            correlationId: selectedEvent.attributes?.correlationId || "",
            hasMoreEvents: false,
            relatedEvents: [],
            relatedEventsLink: "",
            totalEventsCount: 0
        };
        $[6] = t5;
    } else t5 = $[6];
    const relatedEvents = t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            activeMode: "activity",
            activity: {
                activityData: transformedEvent,
                activeTab: "details",
                relatedEvents: relatedEvents
            }
        };
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== handleClose) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e4b375e3823ba65f$export$9c5f261b71e68b6d), {
            sidePanel: t6,
            onClose: handleClose
        });
        $[8] = handleClose;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
};
const $dc07a4d102f2ddf8$var$i18n = (0, $cgtv4.defineMessages)({
    panelSplitter: {
        id: "page-layout.right-panel.resize.label",
        defaultMessage: "Resize panel"
    },
    auditLogClose: {
        id: "page-layout.audit-log-panel.close.label",
        defaultMessage: "Close"
    },
    auditLogContent: {
        id: "page-layout.audit-log-panel.content.label",
        defaultMessage: "Simple side panel content"
    }
});
const $dc07a4d102f2ddf8$export$364a989a35814102 = ({ toggleInProductHelp: toggleInProductHelp })=>{
    const { isLoggedIn: isLoggedIn, isRovoEnabled: isRovoEnabledSessionData, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabledSessionData;
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isRovoEnabled = shouldShowRovo && isLoggedIn;
    const { location: location, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [routeData, setRouteData] = (0, $42omo.useState)({
        routeName: '',
        routeGroup: ''
    });
    const inProductHelpContext = (0, $cLgYq.useInProductHelpActions)();
    const articleId = (0, $cLgYq.useInProductHelpArticleId)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleRovoPanelResizeComplete = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'resized',
                actionSubject: 'aiMatePanel',
                source: 'confluencePanel'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const value = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RIGHT_SIDEBAR);
        if (value) try {
            const { panelId: panelId, articleId: localStorageArticleId } = JSON.parse(value);
            // Check if there was a specific article previously opened
            if (panelId === (0, $dIDyF.HELP_PANEL_ID) && localStorageArticleId) inProductHelpContext.setArticleId(localStorageArticleId);
        } catch (e) {
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                error: e
            });
        }
        if (location) {
            const { routeName: routeName, routeGroup: routeGroup } = (0, $14QAi.getRouteData)(location.pathname);
            setRouteData({
                routeName: routeName,
                routeGroup: routeGroup
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location,
        experienceTracker
    ]);
    // Open a panel if one is persisted in local storage
    (0, $42omo.useEffect)(()=>{
        const value = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RIGHT_SIDEBAR);
        if (value) {
            const { panelId: panelId, panelWidth: panelWidth } = JSON.parse(value);
            const isOtherPanel = ![
                (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID)
            ].includes(panelId);
            if (isOtherPanel) rightSidebarContext.open(panelId, panelWidth);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    // Remove sidebar item from local storage if no sidebars open in context
    (0, $42omo.useEffect)(()=>{
        if (rightSidebarContext.sidebars.length === 0) {
            const value = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RIGHT_SIDEBAR);
            if (value) (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RIGHT_SIDEBAR);
        }
    }, [
        rightSidebarContext
    ]);
    const rightSidebarCurrentState = rightSidebarContext.getCurrent();
    const handleOnCloseHelpPanel = ()=>{
        rightSidebarContext.close((0, $dIDyF.HELP_PANEL_ID));
        // Reset the panel content based on route
        if (location) {
            const { routeName: routeName, routeGroup: routeGroup } = (0, $14QAi.getRouteData)(location.pathname);
            setRouteData({
                routeName: routeName,
                routeGroup: routeGroup
            });
        }
        (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RIGHT_SIDEBAR);
        rightSidebarContext.triggerButtonRef?.current?.focus();
    };
    const handleOnCloseAiMatePanel = ()=>{
        rightSidebarContext.close((0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID));
        (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RIGHT_SIDEBAR);
    };
    const handleOnCloseIssueCreateSidePanel = (panelId)=>{
        rightSidebarContext.close(panelId);
    };
    const handleOnSetArticleId = (articleId)=>{
        inProductHelpContext.setArticleId(articleId);
        if (articleId) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RIGHT_SIDEBAR, JSON.stringify({
            panelId: (0, $dIDyF.HELP_PANEL_ID),
            panelWidth: (0, $dIDyF.HELP_PANEL_WIDTH),
            articleId: articleId
        }));
    };
    const handleOnOpenHelpPanel = (0, $42omo.useCallback)((event)=>{
        const { detail: detail } = event;
        rightSidebarContext.open(detail.panelId, detail.width, detail.isMinimized, detail.toTop);
        inProductHelpContext.setArticleId(detail.articleId);
    }, [
        rightSidebarContext,
        inProductHelpContext
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('openHelpPanel', handleOnOpenHelpPanel);
        return ()=>{
            window.removeEventListener('openHelpPanel', handleOnOpenHelpPanel);
        };
    }, [
        handleOnOpenHelpPanel
    ]);
    /* UseEffect to call toggleInProductHelp based on rightSidebarCurrentState to toggle between
   iph*/ (0, $42omo.useEffect)(()=>{
        const rightSidebarState = rightSidebarContext.getCurrent();
        if (rightSidebarState && !rightSidebarState.isCollapsed && !rightSidebarState.isMinimized) toggleInProductHelp(true);
        else toggleInProductHelp(false);
    }, [
        rightSidebarContext,
        toggleInProductHelp
    ]);
    const shouldDisplaySidebar = rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimized;
    // Open correct sidebar and set localstorage value to persist the panel across refreshes
    const getRightSidePanelElement = ()=>{
        if (!rightSidebarCurrentState) return;
        const { panelId: panelId } = rightSidebarCurrentState;
        if (isRovoEnabled && panelId === (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID)) {
            const sidebarStorageItem = JSON.stringify({
                panelId: (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_ID),
                panelWidth: (0, $5qqdA.CONVERSATION_ASSISTANT_CONTAINER_WIDTH)
            });
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RIGHT_SIDEBAR, sidebarStorageItem);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).AI_MATE
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bssir.PanelSplitter), {
                label: intl.formatMessage($dc07a4d102f2ddf8$var$i18n.panelSplitter),
                onResizeEnd: handleRovoPanelResizeComplete
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWtB.ConfluenceConversationAssistant), {
                onClosePanel: handleOnCloseAiMatePanel
            }));
        }
        if (panelId === (0, $aiS08.ISSUE_CREATE_SIDE_PANEL_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aiS08.IssueCreateSidePanel), {
            onClose: ()=>handleOnCloseIssueCreateSidePanel(panelId)
        }));
        if (panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $UNr39.BulkCreateSidePanel), {
            onClose: ()=>handleOnCloseIssueCreateSidePanel(panelId)
        }));
        if (panelId === (0, $7F52Q.AUDIT_LOG_DETAILS_PANEL)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).AUDIT_LOG
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc07a4d102f2ddf8$var$AuditLogDetailsPanel, null));
        if (panelId === (0, $dIDyF.HELP_PANEL_ID)) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RIGHT_SIDEBAR, JSON.stringify({
                panelId: (0, $dIDyF.HELP_PANEL_ID),
                panelWidth: (0, $dIDyF.HELP_PANEL_WIDTH),
                articleId: articleId,
                routeName: routeData.routeName,
                routeGroup: routeData.routeGroup
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).COLLABORATION
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d70f760b84e45474$export$f5043157c1558e39), {
                isOpen: true,
                articleId: articleId,
                push: push,
                routeGroup: routeData.routeGroup,
                routeName: routeData.routeName,
                onCloseHelpPanel: handleOnCloseHelpPanel,
                onSetArticleId: handleOnSetArticleId
            }));
        }
    };
    if (!shouldDisplaySidebar) return null;
    // Approvals pane is managed by RightSidebarContext, but rendered in ContentContainer
    if (rightSidebarCurrentState?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eK5zz.Panel), {
        defaultWidth: rightSidebarCurrentState?.width || 0,
        testId: "right-sidebar-panel"
    }, getRightSidePanelElement());
};
module.exports["RightPanel"] = $dc07a4d102f2ddf8$export$364a989a35814102;

});

parcelRegister("eK5zz", function(module, exports) {
/* panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bWLcG = parcelRequire("bWLcG");


var $dEIJ1 = parcelRequire("dEIJ1");


var $K0HEo = parcelRequire("K0HEo");


var $8jREP = parcelRequire("8jREP");


var $dGAIk = parcelRequire("dGAIk");


var $bgZhH = parcelRequire("bgZhH");


var $c9vFp = parcelRequire("c9vFp");


var $dh62b = parcelRequire("dh62b");


var $38bxn = parcelRequire("38bxn");


var $5KskV = parcelRequire("5KskV");

const $57f246d928e48214$var$panelSplitterResizingVar = '--n_pnlRsz';
const $57f246d928e48214$var$fallbackDefaultWidth = 365; /**
                                   * We typically use the `defaultWidth` as the minimum resizing width,
                                   * but for large default widths we fallback to a standard value.
                                   *
                                   * This standard value of `400px` is to align with the Global Preview Panels.
                                   */ 
const $57f246d928e48214$var$fallbackResizeMinWidth = 400;
const $57f246d928e48214$var$styles = {
    root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
    border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
    scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
    hidden: "_1e0cglyw"
}; /**
    * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
    *
    * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
    *
    * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
    */ 
function $57f246d928e48214$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $57f246d928e48214$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true }) {
    const dangerouslyHoistSlotSizes = (0, $42omo.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $5KskV.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $57f246d928e48214$var$fallbackDefaultWidth,
        slotName: 'Panel'
    }); /**
       * Don't show the skip link if the slot has 0 width.
       *
       * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
       */ 
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0
    });
    const ref = (0, $42omo.useRef)(null);
    const [width, setWidth] = (0, $42omo.useState)(defaultWidth); // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $42omo.useRef)(defaultWidth); /**
                                                 * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
                                                 * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
                                                 * https://jplat.atlassian.net/browse/BLU-3951
                                                 */ 
    (0, $42omo.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    const sideNavRef = (0, $dh62b.useSideNavRef)(); /**
                                       * The minimum width that the panel can be resized to by the user.
                                       *
                                       * We only use the `defaultWidth` up to a point to avoid huge panels.
                                       */ 
    const minWidth = Math.min(defaultWidth, $57f246d928e48214$var$fallbackResizeMinWidth); /**
                                                                    * Returns the bounds for resizing, evaluated lazily when needed.
                                                                    *
                                                                    * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
                                                                    * and the panel's slot bounds use a complex CSS expression.
                                                                    */ 
    const getResizeBounds = (0, $42omo.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0; /**
                                                                * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
                                                                *
                                                                * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
                                                                */ 
        const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
        return {
            min: `${minWidth}px`,
            max: `${maxWidth}px`
        };
    }, [
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        max: `round(nearest, calc((100vw - var(${(0, $K0HEo.sideNavLiveWidthVar)}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $57f246d928e48214$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            $57f246d928e48214$var$styles.root,
            defaultWidth === 0 && $57f246d928e48214$var$styles.hidden,
            hasBorder && $57f246d928e48214$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $K0HEo.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: (0, $bWLcG.media).above.lg,
                responsiveValue: `var(${$57f246d928e48214$var$panelSplitterResizingVar}, ${panelVariableWidth})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c9vFp.PanelSplitterProvider), {
                panelId: (0, $K0HEo.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $57f246d928e48214$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $57f246d928e48214$var$styles.scrollContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
module.exports["Panel"] = $57f246d928e48214$export$2ddb90ad54e5f587;

});

parcelRegister("aXWtB", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $fwDOR.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};

const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>(await (parcelRequire("k7ZVZ"))).ConfluenceConversationAssistant,
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("k7ZVZ", function(module, exports) {

let $ea7480f8811849b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea7480f8811849b9$var$load("aoJPa").then(()=>parcelRequire('kaQDe'));

});

parcelRegister("5qqdA", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $76e32f06e038930c$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $76e32f06e038930c$export$64aee74ba59709e5 = 439; // px
const $76e32f06e038930c$export$1c07393c5bb1bc27 = 439; // px
const $76e32f06e038930c$export$aa3478deee7adbeb = 350; // px
const $76e32f06e038930c$export$21e515a86cd1733b = 'Chat';
const $76e32f06e038930c$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $76e32f06e038930c$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $76e32f06e038930c$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $76e32f06e038930c$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $76e32f06e038930c$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $76e32f06e038930c$export$e942bf04e23ff966;

});

parcelRegister("jcxYP", function(module, exports) {

let $dfa97f12883b7f4d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dfa97f12883b7f4d$var$load("dHMdi"),
    $dfa97f12883b7f4d$var$load("lId0W"),
    $dfa97f12883b7f4d$var$load("6wr18"),
    $dfa97f12883b7f4d$var$load("9mBQe"),
    $dfa97f12883b7f4d$var$load("j2bbk"),
    $dfa97f12883b7f4d$var$load("1Qnbg"),
    $dfa97f12883b7f4d$var$load("19uFC"),
    $dfa97f12883b7f4d$var$load("ffEVr"),
    $dfa97f12883b7f4d$var$load("hhss7"),
    $dfa97f12883b7f4d$var$load("iOFzT")
]).then(()=>parcelRequire('b8FTv'));

});

parcelRegister("cLgYq", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");

const $80f6c4cf061c88c5$export$909966f260e2b2b = (articleId, setArticleId, routeName, setRouteName, routeGroup, setRouteGroup)=>({
        getArticleId: ()=>articleId,
        setArticleId: setArticleId,
        getRouteName: ()=>routeName,
        setRouteName: setRouteName,
        getRouteGroup: ()=>routeGroup,
        setRouteGroup: setRouteGroup
    });
const $80f6c4cf061c88c5$var$initialInProductHelpState = {
    articleId: '',
    routeName: '',
    routeGroup: ''
};
const $80f6c4cf061c88c5$var$inProductHelpActions = {
    setArticleId: (articleId)=>({ setState: setState })=>{
            setState({
                articleId: articleId
            });
        },
    setRouteName: (routeName)=>({ setState: setState })=>{
            setState({
                routeName: routeName
            });
        },
    setRouteGroup: (routeGroup)=>({ setState: setState })=>{
            setState({
                routeGroup: routeGroup
            });
        }
};
const $80f6c4cf061c88c5$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$80f6c4cf061c88c5$var$initialInProductHelpState
    },
    actions: $80f6c4cf061c88c5$var$inProductHelpActions,
    name: 'inProductHelpContext'
});
const $80f6c4cf061c88c5$export$d9f3a3de6974e16a = (0, $9zUhf.createActionsHook)($80f6c4cf061c88c5$var$Store);
const $80f6c4cf061c88c5$export$b1fca540f7ef5476 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.articleId
});
const $80f6c4cf061c88c5$export$15e1d4730ce65e9d = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeName
});
const $80f6c4cf061c88c5$export$1dfb78b8caec7720 = (0, $9zUhf.createStateHook)($80f6c4cf061c88c5$var$Store, {
    selector: (state)=>state.routeGroup
});
const $80f6c4cf061c88c5$export$a611b87b3ebe1475 = (0, $FOT9i.createContainer)($80f6c4cf061c88c5$var$Store, {
    onInit: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        },
    onUpdate: ()=>({ setState: setState }, productState)=>{
            setState(productState);
        }
});
const $80f6c4cf061c88c5$export$a61d77bd8effd79e = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($80f6c4cf061c88c5$export$a611b87b3ebe1475, null, children);
};
module.exports["useInProductHelpActions"] = $80f6c4cf061c88c5$export$d9f3a3de6974e16a;
module.exports["useInProductHelpArticleId"] = $80f6c4cf061c88c5$export$b1fca540f7ef5476;
module.exports["InProductHelpProvider"] = $80f6c4cf061c88c5$export$a61d77bd8effd79e;

});

parcelRegister("14QAi", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $flE5X = parcelRequire("flE5X");


var $lzcvT = parcelRequire("lzcvT");

const $1ce5a19013c572e5$export$529433b0a9e66822 = (url, isFedrampEnv)=>{
    const isFedrampEnvironment = isFedrampEnv ?? (0, $lzcvT.isFedRamp)();
    if (isFedrampEnvironment) {
        // Transform help-aggregator paths for FedRAMP environment
        // /gateway/api/help-content/v2/* -> /gateway/api/ha/v2/*
        // Stargate handles routing, so return relative path without domain
        if (url.startsWith('/gateway/api/help-content/v2/')) {
            const pathAfterV2 = url.replace('/gateway/api/help-content/v2', '');
            return `/gateway/api/ha/v2${pathAfterV2}`;
        }
        // For non-help-aggregator paths in FedRAMP, return as-is (relative)
        return url;
    }
    // For non-FedRAMP environments, use relative URLs (current behavior)
    return url;
};
// ANALYTICS PROPERTIES
const $1ce5a19013c572e5$var$SPACE_OVERVIEW = 'spaceSettings/overview';
const $1ce5a19013c572e5$var$SPACE_PERMISSIONS = 'spaceSettings/permissions';
const $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS = 'spaceSettings/contentTools';
const $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL = 'spaceSettings/lookAndFeel';
const $1ce5a19013c572e5$var$SPACE_INTEGRATIONS = 'spaceSettings/Integrations';
// ROUTE GROUPS
const $1ce5a19013c572e5$var$SPACE_SETTINGS = 'space-settings';
const $1ce5a19013c572e5$export$244e5242c65921be = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice#13.-Additional-Disclosures-for-California-Residents';
const $1ce5a19013c572e5$export$ab8f8977c5e363cb = 'https://www.atlassian.com/legal/privacy-policy#additional-disclosures-for-ca-residents';
const $1ce5a19013c572e5$export$86f8e0fbd7845b32 = 'https://hello.atlassian.net/wiki/spaces/PMP/pages/139161942/Standard+-+Global+Workplace+Privacy+Notice';
const $1ce5a19013c572e5$export$87259143062a27ea = 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers';
const $1ce5a19013c572e5$export$108231643dc5e01e = [
    'Online Help',
    'Get the mobile app',
    'Feed Builder',
    'Keyboard Shortcuts',
    'Site Status',
    "What\u2019s new",
    'About Confluence'
];
const $1ce5a19013c572e5$export$40e045b7d0d057fd = (route)=>{
    // get what route we're on by switching based on
    // the regex evaluating to true
    switch(true){
        /**
		 * SPACE SETTINGS - OVERVIEW
		 */ case /viewspacesummary/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-details',
                articleId: '2ngx6W7OSkTdvFP6m1jdYC',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'spaceDetailsScreen'
            };
        case /archivespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /archiveSpace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'archive-space',
                articleId: '18AcZoC9QhZZ0lzuMBaZQD',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'archiveSpaceScreen'
            };
        case /editFeatures/.test(route):
            return {
                routeName: 'edit-sidebar',
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                articleId: '6ivofSJlfSXa9IASo00kvA',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'sidebarConfigurationScreen'
            };
        case /removespace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'delete-space',
                articleId: '7edCGN0nkqsvUd9s3AzEq8',
                section: $1ce5a19013c572e5$var$SPACE_OVERVIEW,
                screen: 'deleteSpaceScreen'
            };
        /**
		 * SPACE SETTINGS - PERMISSIONS
		 */ case /spaces\/.*\/settings\/permissions\/\d*/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /spacepermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'space-permissions',
                articleId: '6fQGHt1G8f5KUxXTinTVvW',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'permissionsScreen'
            };
        case /addonpermissions/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'addOnScreen'
            };
        case /listpermissionpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'page-restrictions',
                articleId: '7f9j14trnF75aeuihHAoLp',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'restrictedPagesScreen'
            };
        case /reorderpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'reorder-pages',
                articleId: '5faOvjH2hAw2CpZY3tC3ej',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'reorderPagesScreen'
            };
        case /listorphanedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'orphaned-pages',
                articleId: '1mxG2f1dvIifiDqKrkvy98',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'orphanedPagesScreen'
            };
        case /listundefinedpages/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined-pages',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'undefinedPagesScreen'
            };
        case /listattachmentsforspace/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'attachments',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'attachmentsScreen'
            };
        case /viewtrash/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'trash',
                articleId: '6NL5cRC6aV7k9ucd2yEZzZ',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'trashScreen'
            };
        case /exportspacewelcome/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'export-space',
                articleId: '6RcXthpHKQasH09gERDkE8',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'exportScreen'
            };
        case /listrssfeeds/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'rss-feed',
                articleId: '6TyTkhaowcNTwvq9V0rt10',
                section: $1ce5a19013c572e5$var$SPACE_CONTENT_TOOLS,
                screen: 'rssFeedsScreen'
            };
        /**
		 * SPACE SETTINGS - LOOK AND FEEL
		 */ case /spaces\/choosetheme/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'themes',
                articleId: '3Owkyfl2mshKQQ2mECCV8q',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'themesScreen'
            };
        case /custompagecontent/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'header-and-footer',
                articleId: '2i2NAHbTjkWeoprrdWlNX',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'headerAndFooterScreen'
            };
        case /viewpdfconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfConfigScreen'
            };
        case /viewpdflayoutconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfLayoutScreen'
            };
        case /viewpdfstyleconfig/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_LOOK_AND_FEEL,
                screen: 'pdfStylesheetScreen'
            };
        /**
		 * SPACE SETTINGS - INTEGRATIONS
		 */ case /listentitylinks/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'undefined',
                articleId: '',
                section: $1ce5a19013c572e5$var$SPACE_INTEGRATIONS,
                screen: 'applicationLinksScreen'
            };
        /**
		 * CONNECT ADDONS
		 */ case /analytics\/permissions/.test(route):
            return {
                routeGroup: 'site-settings',
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /atlassian-connect\/space-tools-tab.action/.test(route):
            return {
                routeGroup: $1ce5a19013c572e5$var$SPACE_SETTINGS,
                routeName: 'analytics-permissions',
                articleId: '6yKVtN1tSSrOHTp4TpXtkg',
                section: $1ce5a19013c572e5$var$SPACE_PERMISSIONS,
                screen: 'analyticsPermissionsScreen'
            };
        /**
		 * CONTENT TYPE VIEW PAGES
		 */ case /spaces\/.*\/pages\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-page',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/whiteboard\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-whiteboard',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/database\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-database',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/embed\/\d*/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-embed',
                articleId: '',
                section: 'notTracked',
                screen: 'notTracked'
            };
        case /spaces\/.*\/calendars/.test(route):
            return {
                routeGroup: 'space',
                routeName: 'view-calendars',
                articleId: '85KAXe75f9VdMibJa5FHz',
                section: 'notTracked',
                screen: 'notTracked'
            };
        /**
		 * EVERYTHING ELSE
		 */ default:
            return {
                routeGroup: 'undefined',
                articleId: '',
                section: 'notTracked',
                routeName: 'undefined',
                screen: 'notTracked'
            };
    }
};
const $1ce5a19013c572e5$export$c28bcc688252a1b6 = (error)=>{
    return [
        'algolia',
        'unreachable hosts'
    ].some((err)=>error.message.toLowerCase().includes(err)) || error instanceof (0, $flE5X.NoNetworkError) || error instanceof (0, $hBkCm.BadStatusError) && error.response.status >= 500;
};
module.exports["getFedSupportGatewayURL"] = $1ce5a19013c572e5$export$529433b0a9e66822;
module.exports["INTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$244e5242c65921be;
module.exports["EXTERNAL_NOTICE_AT_COLLECTION_LINK"] = $1ce5a19013c572e5$export$ab8f8977c5e363cb;
module.exports["INTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$86f8e0fbd7845b32;
module.exports["EXTERNAL_PRIVACY_POLICY_LINK"] = $1ce5a19013c572e5$export$87259143062a27ea;
module.exports["FILTERED_MENU_ITEMS"] = $1ce5a19013c572e5$export$108231643dc5e01e;
module.exports["getRouteData"] = $1ce5a19013c572e5$export$40e045b7d0d057fd;
module.exports["isSearchProviderUnreachableError"] = $1ce5a19013c572e5$export$c28bcc688252a1b6;

});

parcelRegister("dIDyF", function(module, exports) {

var $jO9zg = parcelRequire("jO9zg");

const $c2412d4c16af1f46$export$c43c7444da662fa1 = '1';
const $c2412d4c16af1f46$export$e99efa3985fa3c26 = 'in-product-help';
const $c2412d4c16af1f46$export$23aa6670f346c214 = 368;
const $c2412d4c16af1f46$export$dd8cabd06ab03363 = {
    summary: 'summary',
    wasThisHelpful: 'customfield_10081',
    description: 'description',
    reason: 'customfield_10082',
    title: 'customfield_10083',
    contentId: 'customfield_10084',
    contentLink: 'customfield_10088',
    feedbackContext: 'customfield_10047',
    routeGroup: 'customfield_10085',
    routeName: 'customfield_10086',
    customerName: 'customfield_10045',
    email: 'email',
    contactMe: 'customfield_10043'
};
const $c2412d4c16af1f46$export$597555bbf10f10b8 = {
    yes: {
        id: '10182',
        label: 'yes'
    },
    no: {
        id: '10183',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$cd692d959c11a1e9 = {
    noAccurate: {
        id: '10184',
        label: (0, $jO9zg.notAccurateLabel)
    },
    noClear: {
        id: '10185',
        label: (0, $jO9zg.notClearLabel)
    },
    noRelevant: {
        id: '10186',
        label: (0, $jO9zg.notRelevantLabel)
    }
};
const $c2412d4c16af1f46$export$ee3be114bf2680b4 = {
    yes: {
        id: '10109',
        label: 'yes'
    },
    no: {
        id: '10111',
        label: 'no'
    }
};
const $c2412d4c16af1f46$export$31f0ec6fc5b07a82 = 'afae180b-eb61-43c5-bc3f-5f65349a8853';
const $c2412d4c16af1f46$export$d006cfb73688051e = '279';
module.exports["HELP_PANEL_ID"] = $c2412d4c16af1f46$export$e99efa3985fa3c26;
module.exports["HELP_PANEL_WIDTH"] = $c2412d4c16af1f46$export$23aa6670f346c214;
module.exports["FEEDBACK_FIELDS_ID"] = $c2412d4c16af1f46$export$dd8cabd06ab03363;
module.exports["WAS_THIS_HELPFUL_OPTIONS"] = $c2412d4c16af1f46$export$597555bbf10f10b8;
module.exports["FEEDBACK_REASON_OPTIONS"] = $c2412d4c16af1f46$export$cd692d959c11a1e9;
module.exports["CAN_BE_CONTACTED_OPTIONS"] = $c2412d4c16af1f46$export$ee3be114bf2680b4;
module.exports["EMBEDDABLE_KEY"] = $c2412d4c16af1f46$export$31f0ec6fc5b07a82;
module.exports["REQUEST_TYPE_ID"] = $c2412d4c16af1f46$export$d006cfb73688051e;

});

parcelRegister("jO9zg", function(module, exports) {
const $136af91396913aa8$export$653b1475ad2952b = "It wasn\u2019t accurate";
const $136af91396913aa8$export$910eb5168d5e4926 = "It wasn\u2019t clear";
const $136af91396913aa8$export$7e4b37ff0a487bc2 = "It wasn\u2019t relevant";
module.exports["notAccurateLabel"] = $136af91396913aa8$export$653b1475ad2952b;
module.exports["notClearLabel"] = $136af91396913aa8$export$910eb5168d5e4926;
module.exports["notRelevantLabel"] = $136af91396913aa8$export$7e4b37ff0a487bc2;

});

parcelRegister("c2IXc", function(module, exports) {
$parcel$export(module.exports, "AUDIT_LOG_DETAILS_PANEL", () => (parcelRequire("7F52Q")).AUDIT_LOG_DETAILS_PANEL);
$parcel$export(module.exports, "AUDIT_LOG_PANEL_WIDTH", () => (parcelRequire("7F52Q")).AUDIT_LOG_PANEL_WIDTH);
$parcel$export(module.exports, "setAuditLogEvent", () => (parcelRequire("7F52Q")).setAuditLogEvent);
$parcel$export(module.exports, "getAuditLogEvent", () => (parcelRequire("7F52Q")).getAuditLogEvent);
$parcel$export(module.exports, "clearAuditLogEvent", () => (parcelRequire("7F52Q")).clearAuditLogEvent);

var $7F52Q = parcelRequire("7F52Q");


});

parcelRegister("7F52Q", function(module, exports) {
const $977b888b4e10a1e7$export$cf245a76ea1d3680 = 'AUDIT_LOG_DETAILS_PANEL';
const $977b888b4e10a1e7$export$6e27aa63f74a966c = 400; // Increased from 365px
// Simple module-level state for sharing audit log event data
let $977b888b4e10a1e7$var$currentAuditLogEvent = null;
const $977b888b4e10a1e7$export$eb4a95e9caa61e81 = (event)=>{
    $977b888b4e10a1e7$var$currentAuditLogEvent = event;
};
const $977b888b4e10a1e7$export$4a6ff8a5198f23a0 = ()=>{
    return $977b888b4e10a1e7$var$currentAuditLogEvent;
};
const $977b888b4e10a1e7$export$88b98f16466499a6 = ()=>{
    $977b888b4e10a1e7$var$currentAuditLogEvent = null;
};
module.exports["AUDIT_LOG_DETAILS_PANEL"] = $977b888b4e10a1e7$export$cf245a76ea1d3680;
module.exports["AUDIT_LOG_PANEL_WIDTH"] = $977b888b4e10a1e7$export$6e27aa63f74a966c;
module.exports["setAuditLogEvent"] = $977b888b4e10a1e7$export$eb4a95e9caa61e81;
module.exports["getAuditLogEvent"] = $977b888b4e10a1e7$export$4a6ff8a5198f23a0;
module.exports["clearAuditLogEvent"] = $977b888b4e10a1e7$export$88b98f16466499a6;

});

parcelRegister("1vpkQ", function(module, exports) {
const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_WIDTH"] = $f378941f4cbfa1d0$export$48f59b832d015459;

});

parcelRegister("4JDbp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $i7RGj = parcelRequire("i7RGj");

const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;
module.exports["WidthObserver"] = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});

parcelRegister("i7RGj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5EteX = parcelRequire("5EteX");

const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $5EteX.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $0e043a05e9b77ebf$export$ff983d2a2b6112ea;

});

parcelRegister("5EteX", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $63cd7642b16dfa22$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}
module.exports["useInView"] = $63cd7642b16dfa22$export$2f62ee6831462844;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("fVTNs", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bYRk6 = parcelRequire("bYRk6");

const $c32683c3f1554789$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $c32683c3f1554789$export$34282a1f95511a11 = (props)=>{
    const data = $c32683c3f1554789$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children
        })
    });
};
module.exports["ContextWrapper"] = $c32683c3f1554789$export$34282a1f95511a11;

});

parcelRegister("e7URT", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a48dd4fd18e75a65$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a48dd4fd18e75a65$var$isUndefined;

});

parcelRegister("3C50A", function(module, exports) {

var $apAFY = parcelRequire("apAFY");


var $bHD89 = parcelRequire("bHD89");


var $1J0ov = parcelRequire("1J0ov");

const $24a3efb1cf8e29fc$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $bHD89.ANALYTICS_BRIDGE_CHANNEL));
};
const $24a3efb1cf8e29fc$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $24a3efb1cf8e29fc$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $24a3efb1cf8e29fc$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $1J0ov.getImperativeAnalyticsDataFromArguments)(rest);
    $24a3efb1cf8e29fc$export$34ac71ce24cddec2(event, (0, $bHD89.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $24a3efb1cf8e29fc$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $24a3efb1cf8e29fc$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $24a3efb1cf8e29fc$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $24a3efb1cf8e29fc$export$79f423cc3fd39762;

});

parcelRegister("bHD89", function(module, exports) {
const $f220a889fcad0dca$export$f636b5b56f1d624a = 'Screen';
const $f220a889fcad0dca$export$9d2de6eebf7462b5 = 'Drawer';
const $f220a889fcad0dca$export$1171103ea9083ffa = 'Modal';
const $f220a889fcad0dca$export$cae2783c9279926 = 'InlineDialog';
const $f220a889fcad0dca$export$d1123261ca8831d2 = 'Dropdown';
const $f220a889fcad0dca$export$a1562d08625f5d7e = 'UI';
const $f220a889fcad0dca$export$947dac6c72b26f81 = 'TRACK';
const $f220a889fcad0dca$export$f1d537d508d2945a = 'SCREEN';
const $f220a889fcad0dca$export$12346a674644c156 = 'OPERATIONAL';
const $f220a889fcad0dca$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $f220a889fcad0dca$export$f636b5b56f1d624a;
module.exports["MODAL"] = $f220a889fcad0dca$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $f220a889fcad0dca$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $f220a889fcad0dca$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $f220a889fcad0dca$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $f220a889fcad0dca$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $f220a889fcad0dca$export$2ceccf177fae277c;

});

parcelRegister("1J0ov", function(module, exports) {
const $9c601e99598456fc$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $9c601e99598456fc$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $9c601e99598456fc$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $9c601e99598456fc$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $9c601e99598456fc$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $9c601e99598456fc$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $9c601e99598456fc$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $9c601e99598456fc$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $9c601e99598456fc$export$e6baab532ef8c6bf;

});

parcelRegister("hzZxz", function(module, exports) {

var $e7URT = parcelRequire("e7URT");


var $1j3sF = parcelRequire("1j3sF");


var $bHD89 = parcelRequire("bHD89");


var $01od0 = parcelRequire("01od0");

const $50a1a1624abaf5e4$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $01od0.getAnalyticsType)(castedEvent);
    const attributes = (0, $01od0.getAttributes)(castedEvent);
    const source = (0, $01od0.getSource)(castedEvent);
    const actionSubject = (0, $01od0.getActionSubject)(castedEvent);
    if (analyticsType === (0, $bHD89.SCREEN_EVENT_TYPE)) return {
        type: (0, $bHD89.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $bHD89.UI_EVENT_TYPE:
        case 0, $bHD89.TRACK_EVENT_TYPE:
        case 0, $bHD89.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $01od0.getAction)(castedEvent);
                const actionSubjectId = (0, $01od0.getActionSubjectId)(castedEvent);
                const containerId = (0, $01od0.getContainerId)(castedEvent);
                const containerType = (0, $01od0.getContainerType)(castedEvent);
                const objectId = (0, $01od0.getObjectId)(castedEvent);
                const objectType = (0, $01od0.getObjectType)(castedEvent);
                const tags = (0, $01od0.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $50a1a1624abaf5e4$export$1c850cf68c053906;

});

parcelRegister("01od0", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $e7URT = parcelRequire("e7URT");


var $apAFY = parcelRequire("apAFY");


var $lgmus = parcelRequire("lgmus");


var $1j3sF = parcelRequire("1j3sF");


var $da6ky = parcelRequire("da6ky");

const $4b9739432bab74fb$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $4b9739432bab74fb$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $4b9739432bab74fb$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $4b9739432bab74fb$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $4b9739432bab74fb$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($1j3sF)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($e7URT))));
};
const $4b9739432bab74fb$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'source').filter(Boolean));
const $4b9739432bab74fb$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $4b9739432bab74fb$export$6ca3170acb89054 = (event)=>event.payload.action;
const $4b9739432bab74fb$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $4b9739432bab74fb$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerId').filter(Boolean));
const $4b9739432bab74fb$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'containerType').filter(Boolean));
const $4b9739432bab74fb$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectId').filter(Boolean));
const $4b9739432bab74fb$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($apAFY)))($4b9739432bab74fb$var$extractFromContext(event, 'objectType').filter(Boolean));
const $4b9739432bab74fb$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))((0, (/*@__PURE__*/$parcel$interopDefault($5qOzM)))($4b9739432bab74fb$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $4b9739432bab74fb$export$a3569ac53b82a914;
module.exports["getAttributes"] = $4b9739432bab74fb$export$fe94072fee8a6976;
module.exports["getSource"] = $4b9739432bab74fb$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $4b9739432bab74fb$export$6f40cdf6d42c018d;
module.exports["getAction"] = $4b9739432bab74fb$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $4b9739432bab74fb$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $4b9739432bab74fb$export$7c8178cc9001d237;
module.exports["getContainerType"] = $4b9739432bab74fb$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $4b9739432bab74fb$export$fa986b91291934c7;
module.exports["getObjectType"] = $4b9739432bab74fb$export$11cc42aebef2ef3a;
module.exports["getTags"] = $4b9739432bab74fb$export$af63d7414243dad3;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("2Rith", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $j4EkW = parcelRequire("j4EkW");

const $0f73dde994861ed0$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $0f73dde994861ed0$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $j4EkW.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $42omo.useMemo)(()=>{
        $0f73dde994861ed0$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ifW2H.AIEventsInstrumentationContext).Provider, {
        value: contextValue,
        children: children
    });
};
module.exports["AIEventsInstrumentationProvider"] = $0f73dde994861ed0$export$b5d4bc85dfbaa4f8;

});

parcelRegister("7mpOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: shouldShowRovo
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("caRYB", function(module, exports) {
const $d9000e0d99d20134$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $d9000e0d99d20134$export$2a111da947c407d2;

});

parcelRegister("kDhla", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $1P1Tu.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $9zUhf.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $9zUhf.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $9zUhf.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("d3UlG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5NXxU = parcelRequire("5NXxU");


var $iIEgX = parcelRequire("iIEgX");

var $6yCLg = parcelRequire("6yCLg");


var $cPtvM = parcelRequire("cPtvM");


var $kAaxz = parcelRequire("kAaxz");

function $d7c3e272b37735b1$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $42omo.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6yCLg.useStatefulObservableEffect)((0, $cPtvM.convoAIStreamingEffect), (0, $kAaxz.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $iIEgX.useObservableEffect)((input$)=>input$.pipe((0, $5NXxU.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $42omo.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $kAaxz.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $d7c3e272b37735b1$export$d6e2ae1e990d7e71;

});

parcelRegister("6yCLg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXpOY = parcelRequire("aXpOY");

function $725c584c19c66c44$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $aXpOY.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $42omo.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableEffect"] = $725c584c19c66c44$export$916f6bbdfa1987d0;

});

parcelRegister("dchHi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $8C5kA.default)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $42omo.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $42omo.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("4sbrV", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $iyDxB = parcelRequire("iyDxB");


var $h9yJL = parcelRequire("h9yJL");


var $hAuc5 = parcelRequire("hAuc5");

const $c4325a25ee151966$var$serializer = new (0, $h9yJL.JSONTransformer)();
function $c4325a25ee151966$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $hAuc5.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $iyDxB.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $c4325a25ee151966$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $c4325a25ee151966$export$dfca419434f7e5a8;

});

parcelRegister("ai7NK", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $1P1Tu.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $9zUhf.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $9zUhf.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("kmWRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $ecnYn.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    let t4;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop) {
        t4 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: "320px",
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
            appear: true
        }, t4);
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});


//# sourceMappingURL=RightPanel.87bb2c41.js.map
